// frontend/src/pages/TechnicianPage.js
//vercion corregida hoy
//vercion de implementacion
//ver. mejorada con timeout en envios
// Actualizacion ahumentar el tiempo de validacion de sesion a 30 minutos
// source entorno_fast/bin/activate
import React, { useState, useEffect, useCallback } from 'react';
import LoadingSpinner from '../components/common/LoadingSpinner';
import useLoading from '../hooks/useLoading';
import { useSessionValidator } from '../hooks/useSessionValidator';
import InfoCarousel from '../components/InfoCarousel';
import { storageService } from '../services/storageService';
import { API_BASE_URL, getHealthUrl } from '../config';
import { isSimulatorAllowed } from '../utils/envUtils';

const getFormattedDateTime = (date) => {
    try {
        const options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        };
        return date.toLocaleString('es-MX', options);
    } catch (e) {
        return date.toISOString();
    }
};

// Función para comprimir imágenes y agregar marca de agua
const compressImage = async (file, maxSizeMB = 0.3, maxWidth = 1024, maxHeight = 1024, watermarkInfo = null) => {
    return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            // Liberar Object URL inmediatamente
            URL.revokeObjectURL(objectUrl);

            const canvas = document.createElement('canvas');
            let { width, height } = img;

            // Calcular nuevas dimensiones manteniendo aspecto
            if (width > height) {
                if (width > maxWidth) {
                    height = Math.round((height * maxWidth) / width);
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width = Math.round((width * maxHeight) / height);
                    height = maxHeight;
                }
            }

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            // Dibujar marca de agua si viene informada
            if (watermarkInfo) {
                // Configurar estilo de fuente responsivo
                const fontSize = Math.max(12, Math.round(width * 0.022)); // Aprox 2.2% del ancho de la imagen
                ctx.font = `bold ${fontSize}px sans-serif`;
                ctx.textAlign = 'right';
                ctx.textBaseline = 'bottom';

                const lines = [
                    `Téc: ${watermarkInfo.name} (${watermarkInfo.usuario_ffm})`,
                    `Región: ${watermarkInfo.region} | Distrito: ${watermarkInfo.district}`,
                    `GPS: ${watermarkInfo.latitude}, ${watermarkInfo.longitude}`,
                    watermarkInfo.dateTime
                ];

                // Calcular dimensiones del fondo
                const lineHeight = fontSize * 1.35;
                const paddingRight = Math.max(10, Math.round(width * 0.02));
                const paddingBottom = Math.max(10, Math.round(height * 0.02));

                let maxLineWidth = 0;
                lines.forEach(line => {
                    const m = ctx.measureText(line).width;
                    if (m > maxLineWidth) maxLineWidth = m;
                });

                const rectX = width - maxLineWidth - paddingRight - 10;
                const rectY = height - (lines.length * lineHeight) - paddingBottom - 10;
                const rectW = maxLineWidth + 20;
                const rectH = (lines.length * lineHeight) + 20;

                // Dibujar fondo semi-transparente
                ctx.fillStyle = 'rgba(0, 0, 0, 0.45)';
                if (ctx.roundRect) {
                    ctx.beginPath();
                    ctx.roundRect(rectX, rectY, rectW, rectH, 8);
                    ctx.fill();
                } else {
                    ctx.fillRect(rectX, rectY, rectW, rectH);
                }

                // Configurar estilo de texto con outline para máxima legibilidad
                ctx.shadowColor = 'rgba(0, 0, 0, 0.8)';
                ctx.shadowBlur = 4;
                ctx.lineWidth = Math.max(2, Math.round(fontSize * 0.15));
                ctx.strokeStyle = 'black';
                ctx.fillStyle = 'white';

                // Pintar líneas de abajo hacia arriba
                const linesCopy = [...lines];
                linesCopy.reverse().forEach((line, idx) => {
                    const y = height - paddingBottom - (idx * lineHeight) - 5;
                    const x = width - paddingRight - 5;
                    ctx.strokeText(line, x, y);
                    ctx.fillText(line, x, y);
                });
            }

            // Compresión eficiente en máximo 2 pasos para ahorrar CPU y RAM
            const quality = 0.70;
            canvas.toBlob(
                (blob) => {
                    if (!blob) {
                        reject(new Error('Error al generar blob de la imagen'));
                        return;
                    }
                    const sizeMB = blob.size / (1024 * 1024);
                    if (sizeMB > maxSizeMB) {
                        canvas.toBlob(
                            (secondBlob) => {
                                if (!secondBlob) {
                                    resolve(new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() }));
                                    return;
                                }
                                console.log(`📦 Compresión Técnica (Paso 2): ${(file.size / 1024).toFixed(1)} KB -> ${(secondBlob.size / 1024).toFixed(1)} KB`);
                                resolve(new File([secondBlob], file.name, { type: 'image/jpeg', lastModified: Date.now() }));
                            },
                            'image/jpeg',
                            0.50
                        );
                    } else {
                        console.log(`📦 Compresión Técnica (Paso 1): ${(file.size / 1024).toFixed(1)} KB -> ${(blob.size / 1024).toFixed(1)} KB`);
                        resolve(new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() }));
                    }
                },
                'image/jpeg',
                quality
            );
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error('Error al procesar la imagen'));
        };
        img.src = objectUrl;
    });
};


// Componente Toast interno
const Toast = ({ show, message, type, onClose }) => {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [show, onClose]);

    if (!show) return null;

    const getToastColor = () => {
        switch (type) {
            case 'success': return '#28a745';
            case 'error': return '#dc3545';
            case 'warning': return '#ffc107';
            case 'info': return '#17a2b8';
            default: return '#007bff';
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: getToastColor(),
            color: type === 'warning' ? '#000' : 'white',
            padding: '12px 20px',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            maxWidth: '300px',
            fontSize: '14px'
        }}>
            {message}
        </div>
    );
};

const ImageThumbnail = ({ file }) => {
    const [previewUrl, setPreviewUrl] = React.useState(null);

    React.useEffect(() => {
        if (!file) {
            setPreviewUrl(null);
            return;
        }

        if (typeof file === 'string') {
            setPreviewUrl(file);
            return;
        }

        if (file instanceof File || file instanceof Blob) {
            const url = URL.createObjectURL(file);
            setPreviewUrl(url);
            return () => {
                URL.revokeObjectURL(url);
            };
        }
    }, [file]);

    if (!previewUrl) return null;

    return (
        <img
            src={previewUrl}
            alt="Miniatura"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '8px'
            }}
        />
    );
};

const PE_FINDINGS_CATALOG = {
    'CIERRE': [
        { label: 'CIERRE 1N ABIERTO', risk: 'ALTO', hasRisk: true },
        { label: 'CIERRE 1N DAÑADO', risk: 'ALTO', hasRisk: true },
        { label: 'CIERRE 2N DAÑADO', risk: 'ALTO', hasRisk: true },
        { label: 'CIERRE 2N HOLGADO', risk: 'ALTO', hasRisk: true },
        { label: 'CIERRE CAIDO', risk: 'ALTO', hasRisk: true },
        { label: 'CIERRE DE EMPALME HOLGADO', risk: 'ALTO', hasRisk: true },
        { label: 'CIERRE EN PASO VEHICULAR', risk: 'MEDIO', hasRisk: true },
        { label: 'CIERRE NO HOMOLOGADO', risk: 'MEDIO', hasRisk: true },
        { label: 'CIERRE SIN ACCESORIOS DE SUJECIÓN', risk: 'MEDIO', hasRisk: true },
        { label: 'CIERRE SIN ACERO', risk: 'ALTO', hasRisk: true },
        { label: 'DISTANCIA FUERA DE NORMA', risk: 'BAJO', hasRisk: true },
        { label: 'EMPALME EXPUESTO', risk: 'ALTO', hasRisk: true },
        { label: 'SUSTITUIR CIERRE 2N POR CIERRE DE EMPALME', risk: 'MEDIO', hasRisk: true }
    ],
    'GASA': [
        { label: 'GASA CAIDA', risk: 'ALTO', hasRisk: true },
        { label: 'GASA EN LOOP', risk: 'MEDIO', hasRisk: true },
        { label: 'GASA FUERA DE NORMA', risk: 'MEDIO', hasRisk: false },
        { label: 'GASA SIN DISPOSITIVO', risk: 'BAJO', hasRisk: false }
    ],
    'POSTE': [
        { label: 'HERRAJERIA DETERIORADA', risk: 'MEDIO', hasRisk: true },
        { label: 'SIN HERRAJERIA', risk: 'MEDIO', hasRisk: true },
        { label: 'POSTE METALICO SIN NEOPRENO', risk: 'MEDIO', hasRisk: true },
        { label: 'HERRAJERIA INCORRECTA', risk: 'MEDIO', hasRisk: false },
        { label: 'POSTE DETERIORADO', risk: 'BAJO', hasRisk: false }
    ],
    'ETIQUETADO': [
        { label: 'FALTA AUTOENROLLABLE', risk: 'BAJO', hasRisk: false }
    ],
    'RUTA': [
        { label: 'AUMENTAR ALTURA FO', risk: 'ALTO', hasRisk: true },
        { label: 'FO HOLGADA', risk: 'ALTO', hasRisk: true },
        { label: 'FO SIN ACERO', risk: 'MEDIO', hasRisk: true },
        { label: 'REUBICAR FO', risk: 'MEDIO', hasRisk: true },
        { label: 'TUBOS DE FO EXPUESTOS', risk: 'ALTO', hasRisk: true },
        { label: 'FO INDUCIDA', risk: 'ALTO', hasRisk: true },
        { label: 'FO CON EXCESO DE TENSION', risk: 'ALTO', hasRisk: true },
        { label: 'LASHEADO FUERA DE NORMA', risk: 'MEDIO', hasRisk: false },
        { label: 'FO SIN PROTECTOR', risk: 'MEDIO', hasRisk: false },
        { label: 'CABLE MUERTO', risk: 'BAJO', hasRisk: false }
    ],
    'CANALIZADA': [
        { label: 'TAPA DAÑADA', risk: 'ALTO', hasRisk: true },
        { label: 'REGISTRO SIN TAPA', risk: 'ALTO', hasRisk: true },
        { label: 'REGISTRO OBSTRUIDO', risk: 'MEDIO', hasRisk: false },
        { label: 'REGISTRO DETERIORADO', risk: 'MEDIO', hasRisk: true },
        { label: 'REGISTRO ANEGADO', risk: 'ALTO', hasRisk: true },
        { label: 'CIERRE NO HOMOLOGADO PARA REGISTRO', risk: 'ALTO', hasRisk: true },
        { label: 'REGISTRO NO HOMOLOGADO (MEDIDAS INCORRECTAS, SIN RADIALES)', risk: 'ALTO', hasRisk: true }
    ],
    'SIN MANTENIMIENTO': [
        { label: 'SIN HALLAZGOS / SIN MANTENIMIENTO', risk: 'BAJO', hasRisk: false }
    ]
};

const TechnicianPage = () => {

    // Activar validación de sesión
    useSessionValidator(true);
    // Estados del componente
    const [toast, setToast] = useState({ show: false, message: '', type: '' });
    const [formState, setFormState] = useState('initial');
    const [reportId, setReportId] = useState(null);
    const [hasUnsavedData, setHasUnsavedData] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [pauseStartTime, setPauseStartTime] = useState(null);
    const [totalPauseTime, setTotalPauseTime] = useState(0);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [offlineReportId, setOfflineReportId] = useState(null);
    const [syncStatus, setSyncStatus] = useState('idle'); // 'idle', 'syncing', 'success', 'error'
    const [lastSyncTime, setLastSyncTime] = useState(null);
    const [submissionTimeouts, setSubmissionTimeouts] = useState(new Set());
    const [forceUpdate, setForceUpdate] = useState(0);
    const [hasActiveRouteFromServer, setHasActiveRouteFromServer] = useState(false);
    const { isLoading, startLoading, stopLoading, withLoading } = useLoading();
    const [reportData, setReportData] = useState({
        startLocation: null,
        endLocation: null,
        startTime: null,
        endTime: null,
        maintenancePoints: [],
        unrealizablePoints: []
    });

    const [currentPoint, setCurrentPoint] = useState(null);
    const [simulatedLocation, setSimulatedLocation] = useState(null);
    const [peSearchTerm, setPeSearchTerm] = useState('');
    const [peExpandedSections, setPeExpandedSections] = useState({});
    const [simulatedTimeOffsetMinutes, setSimulatedTimeOffsetMinutes] = useState(0);
    const [simPanelPos, setSimPanelPos] = useState({ x: 10, y: null }); // null y = use bottom positioning
    const [isDraggingSimPanel, setIsDraggingSimPanel] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const simPanelRef = React.useRef(null);
    // El simulador solo se habilita en web staging o localhost de desarrollo, NUNCA en APK móvil ni en producción
    const isSimulatorEnabled = isSimulatorAllowed();

    const getSimulatedDate = () => {
        const d = new Date();
        if (isSimulatorEnabled && simulatedTimeOffsetMinutes !== 0) {
            d.setTime(d.getTime() + simulatedTimeOffsetMinutes * 60 * 1000);
        }
        return d;
    };

    // Formatear el offset de tiempo para mostrar en el panel
    const formatTimeOffset = (totalMinutes) => {
        if (totalMinutes === 0) return 'AHORA';
        const sign = totalMinutes > 0 ? '+' : '-';
        const abs = Math.abs(totalMinutes);
        const days = Math.floor(abs / 1440);
        const hours = Math.floor((abs % 1440) / 60);
        const mins = abs % 60;
        let parts = [];
        if (days > 0) parts.push(`${days}d`);
        if (hours > 0) parts.push(`${hours}h`);
        if (mins > 0) parts.push(`${mins}m`);
        return `${sign}${parts.join(' ')}`;
    };

    // Drag handlers para el panel simulador
    const handleSimPanelDragStart = (e) => {
        if (!simPanelRef.current) return;
        const touch = e.touches ? e.touches[0] : e;
        const rect = simPanelRef.current.getBoundingClientRect();
        setDragOffset({ x: touch.clientX - rect.left, y: touch.clientY - rect.top });
        setIsDraggingSimPanel(true);
        e.preventDefault();
    };

    const handleSimPanelDrag = React.useCallback((e) => {
        if (!isDraggingSimPanel) return;
        const touch = e.touches ? e.touches[0] : e;
        const newX = Math.max(0, Math.min(window.innerWidth - 50, touch.clientX - dragOffset.x));
        const newY = Math.max(0, Math.min(window.innerHeight - 50, touch.clientY - dragOffset.y));
        setSimPanelPos({ x: newX, y: newY });
        e.preventDefault();
    }, [isDraggingSimPanel, dragOffset]);

    const handleSimPanelDragEnd = React.useCallback(() => {
        setIsDraggingSimPanel(false);
    }, []);

    React.useEffect(() => {
        if (isDraggingSimPanel) {
            window.addEventListener('mousemove', handleSimPanelDrag);
            window.addEventListener('mouseup', handleSimPanelDragEnd);
            window.addEventListener('touchmove', handleSimPanelDrag, { passive: false });
            window.addEventListener('touchend', handleSimPanelDragEnd);
            return () => {
                window.removeEventListener('mousemove', handleSimPanelDrag);
                window.removeEventListener('mouseup', handleSimPanelDragEnd);
                window.removeEventListener('touchmove', handleSimPanelDrag);
                window.removeEventListener('touchend', handleSimPanelDragEnd);
            };
        }
    }, [isDraggingSimPanel, handleSimPanelDrag, handleSimPanelDragEnd]);

    const moveSimulatedLocation = (metersLat, metersLng) => {
        setSimulatedLocation(prev => {
            const start = prev || { latitude: 25.686667, longitude: -100.316667 };
            // Aprox 1 grado lat = 111,111 metros
            const newLat = start.latitude + (metersLat / 111111);
            // Aprox 1 grado lng = 111,111 * cos(lat) metros
            const newLng = start.longitude + (metersLng / (111111 * Math.cos(start.latitude * Math.PI / 180)));

            const newLoc = {
                latitude: newLat,
                longitude: newLng,
                timestamp: new Date().toISOString()
            };
            showToast(`📍 Ubicación movida: ${newLat.toFixed(6)}, ${newLng.toFixed(6)}`, 'info');
            return newLoc;
        });
    };

    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
    };

    // Función para verificar conexión a internet REAL
    const checkInternetConnection = async () => {
        if (!navigator.onLine) return false;
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 8000);

            const healthUrl = getHealthUrl();
            const response = await fetch(healthUrl, {
                method: 'GET',
                signal: controller.signal,
                headers: { 'Cache-Control': 'no-cache' }
            });
            clearTimeout(timeoutId);
            return response.ok;
        } catch (error) {
            // Si el chequeo específico falla por latencia pero navigator.onLine es true, no asumir falso offline
            return navigator.onLine;
        }
    };

    // Helper para reintentos con backoff exponencial
    const fetchWithRetry = async (url, options, maxRetries = 4) => {
        let retries = 0;
        while (retries < maxRetries) {
            try {
                const isReallyOnline = await checkInternetConnection();
                if (!isReallyOnline) throw new Error('Sin conexión a internet real');

                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 45000); // 45s timeout

                const response = await fetch(url, { ...options, signal: controller.signal });
                clearTimeout(timeoutId);

                if (response.ok) return response;

                if (response.status >= 400 && response.status < 500 && response.status !== 408 && response.status !== 429) {
                    if (response.status === 401) {
                        return response; // Lo manejamos en syncPendingPoints para cerrar sesión
                    }
                    return response;
                }
                throw new Error(`Error HTTP: ${response.status}`);
            } catch (error) {
                retries++;
                if (retries >= maxRetries) throw error;
                const delay = Math.pow(2, retries) * 1000;
                console.log(`⏱️ Reintento ${retries}/${maxRetries} fallido, esperando ${delay}ms...`);
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    };

    // Convierte un File/Blob a base64. Seguro: si ya es string o es null, lo devuelve sin cambios.
    const serializeFile = async (file) => {
        if (!file) return null;
        if (typeof file === 'string') return file; // ya es base64, no hace falta convertir
        if (!(file instanceof Blob)) return null;  // tipo desconocido, descartar
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => resolve(null); // fallo silencioso, no romper el flujo
            reader.readAsDataURL(file);
        });
    };

    // Función para convertir base64 de vuelta a File - CORREGIDA
    const submitWithTimeout = async (submitFunction, fallbackFunction, timeoutMs = 5000, description = 'envío') => {
        const submissionId = Date.now().toString();
        setSubmissionTimeouts(prev => new Set([...prev, submissionId]));

        try {
            // Crear una promesa de timeout
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => {
                    reject(new Error('TIMEOUT'));
                }, timeoutMs);
            });

            // Intentar envío normal con timeout
            await Promise.race([submitFunction(), timeoutPromise]);

            // Si llega aquí, el envío fue exitoso
            showToast(`${description} enviado correctamente`, 'success');

        } catch (error) {
            if (error.message === 'TIMEOUT') {
                console.log(`⏱️ Timeout de ${timeoutMs / 1000}s alcanzado para ${description}, guardando offline...`);

                // Ejecutar función de fallback (guardar offline)
                await fallbackFunction();

                showToast(`${description} guardado offline por conexión lenta. Se enviará automáticamente.`, 'warning');
            } else {
                // Error real de red o servidor
                console.error(`❌ Error en ${description}:`, error);

                // Intentar guardar offline como fallback
                try {
                    await fallbackFunction();
                    showToast(`Error de conexión. ${description} guardado offline.`, 'warning');
                } catch (fallbackError) {
                    console.error(`❌ Error guardando offline:`, fallbackError);
                    showToast(`Error al enviar ${description}`, 'error');
                    throw fallbackError;
                }
            }
        } finally {
            // Limpiar el ID de timeout
            setSubmissionTimeouts(prev => {
                const newSet = new Set(prev);
                newSet.delete(submissionId);
                return newSet;
            });
        }
    };

    const deserializeFile = (base64Data, filename) => {
        if (!base64Data) return null;
        try {
            const arr = base64Data.split(',');
            if (arr.length < 2) return null;
            const mimeMatch = arr[0].match(/:(.*?);/);
            if (!mimeMatch) return null;

            const mime = mimeMatch[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        } catch (e) {
            console.error('❌ Error deserializando archivo:', filename, e);
            return null; // Fallback a null en lugar de crashear
        }
    };

    // Función para crear un reporte en el servidor con datos offline
    const createServerReportFromOffline = async (offlineData) => {
        try {
            setSyncStatus('syncing');
            const token = localStorage.getItem("control_campo_token");
            const formData = new FormData();
            formData.append('start_lat', offlineData.startLocation.latitude.toString());
            formData.append('start_lng', offlineData.startLocation.longitude.toString());
            formData.append('offline_id', offlineReportId.toString());

            const response = await fetchWithRetry(`${API_BASE_URL}/simple-reports/start-route`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${localStorage.getItem("control_campo_token")}` },
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                // Actualizar con el ID real del servidor
                setReportId(data.report_id);
                setOfflineReportId(null);

                // Actualizar los tiempos con los del servidor y reasignar reportId real a los puntos pendientes
                setReportData(prev => ({
                    ...prev,
                    startTime: data.start_time,
                    maintenancePoints: (prev.maintenancePoints || []).map(p => ({
                        ...p,
                        reportId: data.report_id
                    })),
                    unrealizablePoints: (prev.unrealizablePoints || []).map(p => ({
                        ...p,
                        reportId: data.report_id
                    }))
                }));

                setSyncStatus('success');
                setLastSyncTime(new Date());
                return data.report_id;
            } else {
                setSyncStatus('error');
                throw new Error(data.detail || 'Error del servidor');
            }
        } catch (error) {
            console.error('Error creando reporte desde offline:', error);
            setSyncStatus('error');
            throw error;
        }
    };

    // Función para intentar enviar puntos pendientes
    const syncPendingPoints = async () => {
        await withLoading('syncPending', async () => {
            console.log('🔄 Intentando sincronizar puntos pendientes...');

            // 🔒 Guard: si ya estamos sincronizando, ignorar esta llamada
            if (syncStatus === 'syncing') {
                console.log('⏳ Sincronización ya en curso, ignorando llamada duplicada');
                return;
            }

            try {

                setSyncStatus('syncing');

                const token = localStorage.getItem("control_campo_token");
                if (!token) {
                    console.log('❌ No hay token, no se puede sincronizar');
                    setSyncStatus('error');
                    return;
                }

                // Si tenemos un ID offline, primero crear el reporte en el servidor
                let realReportId = reportId;
                if (offlineReportId && reportData.startLocation) {
                    try {
                        realReportId = await createServerReportFromOffline(reportData);
                        showToast('Reporte offline sincronizado con el servidor', 'success');
                    } catch (error) {
                        console.error('Error sincronizando reporte offline:', error);
                        showToast('Error sincronizando reporte offline', 'error');
                        setSyncStatus('error');
                        return;
                    }
                }

                let syncedCount = 0;
                let errors = 0;

                // 1. Sincronizar segmentos pendientes
                for (const point of (reportData.maintenancePoints || []).filter(p => !p.submitted)) {
                    try {
                        console.log('🔄 ========================================');
                        console.log('🔄 SINCRONIZANDO SEGMENTO OFFLINE');
                        console.log('🔄 ========================================');
                        console.log('📦 Datos del punto:', {
                            id: point.id,
                            timestamp_captura: point.timestamp,
                            minutos_desde_captura: Math.round((new Date().getTime() - new Date(point.timestamp).getTime()) / 60000),
                            location: point.location
                        });

                        if (!point.location ||
                            typeof point.location.latitude !== 'number' ||
                            typeof point.location.longitude !== 'number') {
                            console.error('❌ ERROR: Coordenadas inválidas:', point.location);
                            errors++;
                            continue;
                        }

                        // 🆕 CAPTURAR UBICACIÓN ACTUAL PARA COMPARAR
                        let ubicacionActual = null;
                        try {
                            ubicacionActual = await getCurrentLocation();
                            const distancia = calcularDistancia(
                                point.location.latitude,
                                point.location.longitude,
                                ubicacionActual.latitude,
                                ubicacionActual.longitude
                            );

                            console.log('📍 COMPARACIÓN DE COORDENADAS:');
                            console.log('  ├─ Capturadas (momento del segmento):', {
                                lat: point.location.latitude.toFixed(7),
                                lng: point.location.longitude.toFixed(7),
                                timestamp: point.timestamp
                            });
                            console.log('  ├─ Actuales (momento de sincronización):', {
                                lat: ubicacionActual.latitude.toFixed(7),
                                lng: ubicacionActual.longitude.toFixed(7),
                                timestamp: new Date().toISOString()
                            });
                            console.log(`  └─ Distancia entre ambas: ${distancia} metros`);

                            if (distancia > 500) { // Más de 500 metros
                                console.warn(`⚠️ ADVERTENCIA: El técnico se movió ${distancia}m desde que capturó este segmento`);
                            }
                        } catch (e) {
                            showToast('GPS inactivo o muy lento, usando última ubicación conocida...', 'warning');
                            console.log('⚠️ No se pudo obtener ubicación actual para comparar:', e.message);
                        }

                        console.log('📤 ENVIANDO AL BACKEND:', {
                            report_id: realReportId,
                            latitude: point.location.latitude.toString(),
                            longitude: point.location.longitude.toString()
                        });

                        const formData = new FormData();
                        // Usar reportId real del servidor si el del punto es offline/temporal
                        const isTempId = (id) => !id || (typeof id === 'string' && id.startsWith('offline')) || Number(id) > 10000000000 || id === offlineReportId;
                        const targetId = (realReportId || reportId) || (!isTempId(point.reportId) ? point.reportId : null);
                        if (!targetId || isTempId(targetId)) {
                            console.warn('⚠️ No se puede sincronizar punto sin ID de reporte real en el servidor:', targetId);
                            errors++;
                            continue;
                        }
                        formData.append('report_id', targetId.toString());
                        formData.append('latitude', point.location.latitude.toString());
                        formData.append('longitude', point.location.longitude.toString());
                        formData.append('created_at', point.timestamp);
                        // 🆕 Usar sentAt (cuando el técnico presionó Enviar), nunca la hora de sincronización
                        formData.append('submitted_at', point.sentAt || new Date().toISOString());

                        if (point.activities) {
                            formData.append('activities', JSON.stringify(point.activities));
                        }
                        // 📱 Envío silencioso del estado del dispositivo en el momento de sincronización
                        const offlineDevStatus = await checkNativeDeviceStatus();
                        formData.append('is_capacitor', offlineDevStatus.is_capacitor?.toString() || 'false');
                        formData.append('is_dev_mode', offlineDevStatus.is_dev_mode?.toString() || 'false');
                        formData.append('is_mock_location_active', offlineDevStatus.is_mock_location_active?.toString() || 'false');
                        formData.append('was_offline', 'true'); // 📴 Sincronizado desde cola offline
                        const photo1 = point.photos && typeof point.photos.segment1 === 'string'
                            ? deserializeFile(point.photos.segment1, `segment1_${point.id}.jpg`)
                            : point.photos?.segment1 || null;
                        const photo2 = point.photos && typeof point.photos.segment2 === 'string'
                            ? deserializeFile(point.photos.segment2, `segment2_${point.id}.jpg`)
                            : point.photos?.segment2 || null;

                        if (photo1) formData.append('photo1', photo1);
                        if (photo2) formData.append('photo2', photo2);

                        const response = await fetchWithRetry(`${API_BASE_URL}/simple-reports/segment-report`, {
                            method: 'POST',
                            headers: { 'Authorization': `Bearer ${token}` },
                            body: formData
                        });

                        if (response.ok) {
                            const responseData = await response.json();
                            console.log('✅ Sincronizado exitosamente. Respuesta:', responseData);

                            setReportData(prev => ({
                                ...prev,
                                maintenancePoints: prev.maintenancePoints.map(p =>
                                    // Conservar el sentAt original; submittedAt = hora de confirmación del servidor
                                    // 🆕 Actualizar el id local con el segment_id real de la BD
                                    p.id === point.id ? {
                                        ...p,
                                        id: responseData.segment_id || p.id,
                                        photos: { segment1: null, segment2: null },
                                        submitted: true,
                                        submittedAt: new Date().toISOString()
                                    } : p
                                )
                            }));
                            syncedCount++;
                        } else {
                            const errorData = await response.json();
                            console.error('❌ Error del servidor:', errorData);
                            if (response.status === 401) {
                                showToast('Tu sesión expiró. Por favor, vuelve a iniciar sesión.', 'error');
                                setSyncStatus('error');
                                setTimeout(() => { window.location.href = '/login'; }, 2000);
                                return; // Stop sync completely
                            }
                            errors++;
                        }
                    } catch (error) {
                        console.error('❌ Exception sincronizando segmento:', error);
                        errors++;
                    }
                }

                // 2. Sincronizar puntos no realizables pendientes
                for (const point of (reportData.unrealizablePoints || []).filter(p => !p.submitted)) {
                    try {
                        const formData = new FormData();
                        const isTempId = (id) => !id || (typeof id === 'string' && id.startsWith('offline')) || Number(id) > 10000000000 || id === offlineReportId;
                        const targetId = (realReportId || reportId) || (!isTempId(point.reportId) ? point.reportId : null);
                        if (!targetId || isTempId(targetId)) {
                            console.warn('⚠️ No se puede sincronizar punto no realizable sin ID de reporte real:', targetId);
                            continue;
                        }
                        formData.append('report_id', targetId.toString());
                        formData.append('latitude', point.location.latitude.toString());
                        formData.append('longitude', point.location.longitude.toString());
                        formData.append('reason', point.reason);
                        formData.append('comments', point.comments);
                        formData.append('created_at', point.timestamp);
                        // 🆕 Usar sentAt (cuando el técnico presionó Enviar), nunca la hora de sincronización
                        formData.append('submitted_at', point.sentAt || new Date().toISOString());
                        formData.append('was_offline', 'true'); // 📴 Sincronizado desde cola offline

                        const evidencePhoto = typeof point.evidencePhoto === 'string'
                            ? deserializeFile(point.evidencePhoto, `evidence_${point.id}.jpg`)
                            : point.evidencePhoto;

                        if (evidencePhoto) formData.append('evidence_photo', evidencePhoto);

                        const response = await fetchWithRetry(`${API_BASE_URL}/simple-reports/unrealizable-point`, {
                            method: 'POST',
                            headers: { 'Authorization': `Bearer ${token}` },
                            body: formData
                        });

                        if (response.ok) {
                            setReportData(prev => ({
                                ...prev,
                                unrealizablePoints: (prev.unrealizablePoints || []).map(p =>
                                    p.id === point.id ? { ...p, evidencePhoto: null, submitted: true, submittedAt: new Date().toISOString() } : p
                                )
                            }));
                            syncedCount++;
                        } else {
                            if (response.status === 401) {
                                showToast('Tu sesión expiró. Por favor, vuelve a iniciar sesión.', 'error');
                                setSyncStatus('error');
                                setTimeout(() => { window.location.href = '/login'; }, 2000);
                                return;
                            }
                            errors++;
                        }
                    } catch (error) {
                        console.error('❌ Error sincronizando punto no realizable:', error);
                        errors++;
                    }
                }

                // 3. Si el recorrido fue finalizado offline, sincronizar el final
                if (reportData.offline && reportData.endLocation && realReportId) {
                    if (errors > 0) {
                        console.warn('⚠️ No se sincroniza el cierre porque hay segmentos con error.');
                        // No podemos enviar finish-route porque cerraría el reporte en BD y dejaría perdidos los segmentos
                    } else {
                        try {
                            const token = localStorage.getItem("control_campo_token");
                            const formData = new FormData();
                            formData.append('report_id', realReportId.toString());
                            formData.append('end_lat', reportData.endLocation.latitude.toString());
                            formData.append('end_lng', reportData.endLocation.longitude.toString());
                            formData.append('total_work_minutes', reportData.totalWorkTime.toString());

                            const response = await fetchWithRetry(`${API_BASE_URL}/simple-reports/finish-route`, {
                                method: 'POST',
                                headers: { 'Authorization': `Bearer ${token}` },
                                body: formData
                            });

                            const data = await response.json();

                            if (data.success) {
                                setReportData(prev => ({
                                    ...prev,
                                    offline: false,
                                    endTime: data.completed_at || prev.endTime,
                                    inactividad: data.inactividad || prev.inactividad
                                }));
                                syncedCount++;
                                showToast('Recorrido finalizado sincronizado correctamente', 'success');
                            } else {
                                errors++;
                            }
                        } catch (error) {
                            console.error('Error sincronizando finalización de recorrido:', error);
                            errors++;
                        }
                    } // Cierre del else de errors > 0
                }

                if (syncedCount > 0) {
                    showToast(`✅ ${syncedCount} elementos sincronizados`, 'success');
                    setSyncStatus('success');
                    setLastSyncTime(new Date());
                } else if (errors > 0) {
                    showToast(`⚠️ ${errors} elementos no se pudieron sincronizar`, 'warning');
                    setSyncStatus('error');
                } else {
                    showToast('No hay elementos pendientes por sincronizar', 'info');
                    setSyncStatus('idle');
                }

            } catch (fatalError) {
                console.error('❌ Error interno fatal en syncPendingPoints:', fatalError);
                showToast('Error interno al sincronizar. Se continuará intentando.', 'error');
                setSyncStatus('error');
            }
        }); // <-- Cierre del withLoading
    };

    const syncSingleSegment = async (point) => {
        if (!isOnline) {
            showToast('No hay conexión a internet', 'error');
            return;
        }
        await withLoading(`sync-${point.id}`, async () => {
            try {
                let realReportId = reportId;
                if (offlineReportId && reportData.startLocation) {
                    realReportId = await createServerReportFromOffline(reportData);
                    if (!realReportId) throw new Error('No se pudo crear el reporte offline en el servidor');
                }

                const token = localStorage.getItem("control_campo_token");
                const isTempId = (id) => !id || (typeof id === 'string' && id.startsWith('offline')) || Number(id) > 10000000000 || id === offlineReportId;
                const targetId = (realReportId || reportId) || (!isTempId(point.reportId) ? point.reportId : null);
                if (!targetId || isTempId(targetId)) {
                    throw new Error('No se encontró un reporte activo en el servidor para asociar el segmento');
                }

                const formData = new FormData();
                formData.append('report_id', targetId.toString());
                formData.append('latitude', point.location.latitude.toString());
                formData.append('longitude', point.location.longitude.toString());
                formData.append('created_at', point.timestamp);
                formData.append('submitted_at', point.sentAt || new Date().toISOString());
                formData.append('is_mocked', point.isMocked ? 'true' : 'false');

                if (point.activities) {
                    formData.append('activities', JSON.stringify(point.activities));
                }

                const offlineDevStatus = await checkNativeDeviceStatus();
                formData.append('is_capacitor', offlineDevStatus.is_capacitor?.toString() || 'false');
                formData.append('is_dev_mode', offlineDevStatus.is_dev_mode?.toString() || 'false');
                formData.append('is_mock_location_active', offlineDevStatus.is_mock_location_active?.toString() || 'false');
                formData.append('was_offline', 'true'); // 📴 Sincronizado individualmente desde cola offline

                const photo1 = point.photos && typeof point.photos.segment1 === 'string'
                    ? deserializeFile(point.photos.segment1, `segment1_${point.id}.jpg`)
                    : point.photos?.segment1 || null;
                const photo2 = point.photos && typeof point.photos.segment2 === 'string'
                    ? deserializeFile(point.photos.segment2, `segment2_${point.id}.jpg`)
                    : point.photos?.segment2 || null;

                if (photo1) formData.append('photo1', photo1);
                if (photo2) formData.append('photo2', photo2);

                const response = await fetchWithRetry(`${API_BASE_URL}/simple-reports/segment-report`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });

                if (response.ok) {
                    const responseData = await response.json();
                    setReportData(prev => ({
                        ...prev,
                        maintenancePoints: prev.maintenancePoints.map(p =>
                            p.id === point.id ? { ...p, id: responseData.segment_id || p.id, photos: { segment1: null, segment2: null }, submitted: true, submittedAt: new Date().toISOString() } : p
                        )
                    }));
                    showToast('Segmento enviado correctamente', 'success');
                } else {
                    if (response.status === 401) {
                        showToast('Tu sesión expiró', 'error');
                        setTimeout(() => { window.location.href = '/login'; }, 2000);
                        return;
                    }
                    showToast('Error al enviar segmento', 'error');
                }
            } catch (error) {
                console.error('Error enviando segmento individual:', error);
                showToast('Error de red al enviar segmento', 'error');
            }
        });
    };

    const syncSingleUnrealizable = async (point) => {
        if (!isOnline) {
            showToast('No hay conexión a internet', 'error');
            return;
        }
        await withLoading(`unrealizable-${point.id}`, async () => {
            try {
                let realReportId = reportId;
                if (offlineReportId && reportData.startLocation) {
                    realReportId = await createServerReportFromOffline(reportData);
                    if (!realReportId) throw new Error('No se pudo crear el reporte offline en el servidor');
                }

                const token = localStorage.getItem("control_campo_token");
                const isTempId = (id) => !id || (typeof id === 'string' && id.startsWith('offline')) || Number(id) > 10000000000 || id === offlineReportId;
                const targetId = (realReportId || reportId) || (!isTempId(point.reportId) ? point.reportId : null);
                if (!targetId || isTempId(targetId)) {
                    throw new Error('No se encontró un reporte activo en el servidor para asociar el punto no realizable');
                }

                const formData = new FormData();
                formData.append('report_id', targetId.toString());
                formData.append('latitude', point.location.latitude.toString());
                formData.append('longitude', point.location.longitude.toString());
                formData.append('reason', point.reason);
                formData.append('comments', point.comments || '');
                formData.append('created_at', point.timestamp);
                formData.append('submitted_at', point.sentAt || new Date().toISOString());
                formData.append('was_offline', 'true'); // 📴 Sincronizado individualmente desde cola offline

                const evidencePhoto = typeof point.evidencePhoto === 'string'
                    ? deserializeFile(point.evidencePhoto, `evidence_${point.id}.jpg`)
                    : point.evidencePhoto;
                if (evidencePhoto) formData.append('evidence_photo', evidencePhoto);

                const response = await fetchWithRetry(`${API_BASE_URL}/simple-reports/unrealizable-point`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });

                if (response.ok) {
                    setReportData(prev => ({
                        ...prev,
                        unrealizablePoints: (prev.unrealizablePoints || []).map(p =>
                            p.id === point.id ? { ...p, evidencePhoto: null, submitted: true, submittedAt: new Date().toISOString() } : p
                        )
                    }));
                    showToast('Punto no realizable enviado', 'success');
                } else {
                    showToast('Error al enviar punto no realizable', 'error');
                }
            } catch (error) {
                console.error('Error enviando punto no realizable individual:', error);
                showToast('Error de red al enviar punto', 'error');
            }
        });
    };

    // Mejorar la función de guardado para incluir las fotos en localStorage
    const saveToLocalStorage = useCallback(async () => {
        if (formState !== 'initial') {
            try {
                // Serializar todos los datos incluyendo archivos
                const serializeData = async (data) => {
                    const serialized = { ...data };

                    // Serializar fotos de puntos actuales
                    if (currentPoint) {
                        serialized.currentPoint = {
                            ...currentPoint,
                            photos: {
                                segment1: await serializeFile(currentPoint.photos.segment1),
                                segment2: await serializeFile(currentPoint.photos.segment2)
                            }
                        };
                    }

                    // Serializar fotos de puntos de mantenimiento pendientes
                    serialized.maintenancePoints = await Promise.all(
                        data.maintenancePoints.map(async (point) => {
                            if (point.submitted) {
                                return { ...point, photos: { segment1: null, segment2: null } };
                            }
                            return {
                                ...point,
                                photos: {
                                    segment1: typeof point.photos.segment1 === 'string'
                                        ? point.photos.segment1
                                        : await serializeFile(point.photos.segment1),
                                    segment2: typeof point.photos.segment2 === 'string'
                                        ? point.photos.segment2
                                        : await serializeFile(point.photos.segment2)
                                }
                            };
                        })
                    );

                    // Serializar fotos de puntos no realizables pendientes
                    serialized.unrealizablePoints = await Promise.all(
                        data.unrealizablePoints.map(async (point) => {
                            if (point.submitted) {
                                return { ...point, evidencePhoto: null };
                            }
                            return {
                                ...point,
                                evidencePhoto: typeof point.evidencePhoto === 'string'
                                    ? point.evidencePhoto
                                    : await serializeFile(point.evidencePhoto)
                            };
                        })
                    );

                    return serialized;
                };

                const serializedData = await serializeData(reportData);
                const dataToSave = {
                    reportData: serializedData,
                    currentPoint: currentPoint ? {
                        ...currentPoint,
                        photos: {
                            segment1: await serializeFile(currentPoint.photos.segment1),
                            segment2: await serializeFile(currentPoint.photos.segment2)
                        }
                    } : null,
                    state: formState,
                    reportId,
                    offlineReportId,
                    isPaused,
                    pauseStartTime,
                    totalPauseTime,
                    syncStatus,
                    lastSyncTime: lastSyncTime ? lastSyncTime.toISOString() : null
                };

                await storageService.saveFormData(dataToSave);
            } catch (error) {
                console.error('Error guardando en IndexedDB (storageService):', error);
            }
        }
    }, [reportData, formState, currentPoint, reportId, offlineReportId, isPaused, pauseStartTime, totalPauseTime, syncStatus, lastSyncTime]);

    // Detectar cambios de conexión reales
    useEffect(() => {
        const verifyConnection = async () => {
            const online = await checkInternetConnection();
            setIsOnline(online);
            if (online && (reportId || offlineReportId) && formState === 'active') {
                syncPendingPoints();
            }
        };

        const handleOnline = () => {
            console.log('🌐 Conexión restaurada detectada - Verificando con backend...');
            // Esperar un poco y verificar la conexión real
            setTimeout(async () => {
                const isReallyOnline = await checkInternetConnection();
                if (isReallyOnline) {
                    setIsOnline(true);
                    showToast('Conexión restaurada. Sincronizando datos...', 'info');
                    if ((reportId || offlineReportId) && formState === 'active') {
                        syncPendingPoints();
                    }
                } else {
                    console.log('Falsa alarma: red conectada pero sin internet');
                }
            }, 2000);
        };

        const handleOffline = () => {
            console.log('📴 Sin conexión - Modo offline activado');
            setIsOnline(false);
            showToast('Modo offline activado. Los datos se guardarán localmente.', 'warning');
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Verificar conexión al cargar
        verifyConnection();

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, [reportId, offlineReportId, formState]);

    // Sincronización automática cada 2 minutos cuando hay conexión
    useEffect(() => {
        const syncInterval = setInterval(async () => {
            const isReallyOnline = await checkInternetConnection();
            setIsOnline(isReallyOnline); // Actualiza estado visual
            if (isReallyOnline && (reportId || offlineReportId) && formState === 'active') {
                syncPendingPoints();
            }
        }, 120000); // 2 minutos

        return () => clearInterval(syncInterval);
    }, [reportId, offlineReportId, formState]);

    // Cargar datos del usuario y localStorage
    useEffect(() => {
        const loadUserData = async () => {
            try {
                const token = (typeof window !== 'undefined' && window.localStorage) ? localStorage.getItem('control_campo_token') : null
                if (!token) {
                    console.warn('No hay sesión activa, redirigiendo a login');
                    window.location.href = '/login';
                    return;
                }

                // Cargar perfil del usuario
                try {
                    console.log('🔍 Attempting to fetch profile from backend...');
                    const response = await fetch(`${API_BASE_URL}/auth/profile`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    });

                    if (response.ok) {
                        const userData = await response.json();
                        setUser({
                            name: userData.full_name,
                            district: userData.distrito,
                            region: userData.region,
                            usuario_ffm: userData.usuario_ffm,
                            role: userData.role,
                            tipo_planta: userData.tipo_planta || 'PI'
                        });
                    } else {
                        throw new Error(`HTTP ${response.status}`);
                    }
                } catch (error) {
                    console.warn('⚠️ Using localStorage data as fallback due to error:', error.message);
                    const userInfo = JSON.parse(localStorage.getItem('control_campo_user') || '{}');
                    setUser({
                        name: userInfo.full_name || 'Usuario',
                        district: userInfo.distrito || 'N/A',
                        region: userInfo.region || 'N/A',
                        usuario_ffm: userInfo.usuario_ffm || 'N/A',
                        role: userInfo.role || 'technician',
                        tipo_planta: userInfo.tipo_planta || 'PI'
                    });
                }
            } catch (error) {
                console.error('Error cargando usuario:', error);
                setUser({
                    name: 'Usuario',
                    district: 'N/A',
                    region: 'N/A',
                    usuario_ffm: 'N/A',
                    role: 'technician',
                    tipo_planta: 'PI'
                });
            } finally {
                setLoading(false);
            }

            // Cargar datos guardados si existen en IndexedDB
            const savedData = await storageService.getFormData();
            if (savedData) {
                try {
                    const parsed = savedData; // Ya viene parseado de IndexedDB

                    // Validar y corregir fechas de forma segura
                    const validateAndFixDates = (data) => {
                        if (data && typeof data === 'object') {
                            if (data.startTime && typeof data.startTime === 'string' &&
                                (data.startTime.includes('1969') || data.startTime === "0")) {
                                console.warn('Fecha inválida detectada en localStorage, limpiando...');
                                delete data.startTime;
                            }
                            if (data.endTime && typeof data.endTime === 'string' &&
                                (data.endTime.includes('1969') || data.endTime === "0")) {
                                delete data.endTime;
                            }
                        }
                        return data;
                    };

                    const fixedData = validateAndFixDates(parsed.reportData) || {
                        startLocation: null,
                        endLocation: null,
                        startTime: null,
                        endTime: null,
                        maintenancePoints: [],
                        unrealizablePoints: []
                    };

                    setReportData(fixedData);
                    setFormState(parsed.state || 'initial');
                    setReportId(parsed.reportId);
                    setOfflineReportId(parsed.offlineReportId || null);
                    setIsPaused(parsed.isPaused || false);
                    setPauseStartTime(parsed.pauseStartTime);
                    setTotalPauseTime(parsed.totalPauseTime || 0);
                    setSyncStatus(parsed.syncStatus || 'idle');
                    setLastSyncTime(parsed.lastSyncTime ? new Date(parsed.lastSyncTime) : null);
                    if (parsed.isPaused && parsed.pauseStartTime && parsed.state === 'lunch') {
                        const elapsedTime = Math.round(
                            (new Date().getTime() - new Date(parsed.pauseStartTime).getTime()) / (1000 * 60)
                        );

                        if (elapsedTime > 5) {
                            showToast(
                                `Se detectó una pausa local de ${elapsedTime} minutos.`,
                                'warning'
                            );
                        }
                    }

                    // Restaurar currentPoint si existe
                    if (parsed.currentPoint) {
                        setCurrentPoint(parsed.currentPoint);
                    }

                    // Verificar con el backend si todavía existe el reporte
                    if (parsed.reportId && parsed.state !== 'initial' && parsed.state !== 'finished') {
                        try {
                            const response = await fetch(`${API_BASE_URL}/simple-reports/report/${parsed.reportId}`, {
                                headers: { 'Authorization': `Bearer ${localStorage.getItem("control_campo_token")}` }
                            });

                            if (response.ok) {
                                const reportData = await response.json();
                                if (reportData.success) {
                                    // Transformar datos del backend
                                    const backendMaintenancePoints = reportData.segments.map(segment => ({
                                        id: segment.id,
                                        location: {
                                            latitude: parseFloat(segment.latitude),
                                            longitude: parseFloat(segment.longitude)
                                        },
                                        photos: {
                                            segment1: segment.photo1_path,
                                            segment2: segment.photo2_path
                                        },
                                        timestamp: segment.created_at || segment.submitted_at,
                                        submitted: true,
                                        submittedAt: segment.submitted_at
                                    }));

                                    const backendUnrealizablePoints = reportData.unrealizable_points.map(point => ({
                                        id: point.id,
                                        location: {
                                            latitude: parseFloat(point.latitude),
                                            longitude: parseFloat(point.longitude)
                                        },
                                        reason: point.reason,
                                        comments: point.comments,
                                        evidencePhoto: point.evidence_photo_path,
                                        timestamp: point.created_at || point.submitted_at,
                                        submitted: true,
                                        submittedAt: point.submitted_at,
                                        type: 'unrealizable'
                                    }));

                                    // Combinar datos locales con datos del backend - con de-duplicación por timestamp robusta
                                    const isSameTime = (t1, t2) => {
                                        if (!t1 || !t2) return false;
                                        try {
                                            const d1 = new Date(t1).getTime();
                                            const d2 = new Date(t2).getTime();
                                            return !isNaN(d1) && !isNaN(d2) && Math.abs(d1 - d2) < 5000;
                                        } catch (e) {
                                            return t1 === t2;
                                        }
                                    };

                                    setReportData(prev => {
                                        const currentServerId = reportData?.report?.id || null;
                                        // Filtrar puntos locales que ya están en el backend analizando el timestamp (created_at)
                                        const unsubmittedLocalMaintenance = prev.maintenancePoints.filter(p => {
                                            if (p.submitted) return false;
                                            // Si el timestamp local existe en el backend, es un duplicado
                                            return !backendMaintenancePoints.some(bp => isSameTime(bp.timestamp, p.timestamp));
                                        }).map(p => ({
                                            ...p,
                                            reportId: currentServerId || p.reportId
                                        }));

                                        const unsubmittedLocalUnrealizable = prev.unrealizablePoints.filter(p => {
                                            if (p.submitted) return false;
                                            return !backendUnrealizablePoints.some(bp => isSameTime(bp.timestamp, p.timestamp));
                                        }).map(p => ({
                                            ...p,
                                            reportId: currentServerId || p.reportId
                                        }));

                                        return {
                                            ...prev,
                                            startTime: reportData.report.start_time,
                                            startLocation: reportData.report.start_latitude ? {
                                                latitude: parseFloat(reportData.report.start_latitude),
                                                longitude: parseFloat(reportData.report.start_longitude)
                                            } : prev.startLocation,
                                            endLocation: reportData.report.end_latitude ? {
                                                latitude: parseFloat(reportData.report.end_latitude),
                                                longitude: parseFloat(reportData.report.end_longitude)
                                            } : prev.endLocation,
                                            maintenancePoints: [
                                                ...unsubmittedLocalMaintenance,
                                                ...backendMaintenancePoints
                                            ],
                                            unrealizablePoints: [
                                                ...unsubmittedLocalUnrealizable,
                                                ...backendUnrealizablePoints
                                            ]
                                        };
                                    });

                                    // 🆕 NUEVO: Si el reporte ya está finalizado en el servidor, sincronizar estado local
                                    if (reportData.report.status === 'completed') {
                                        console.log('✅ El reporte ya está finalizado en el servidor. Sincronizando estado...');
                                        setFormState('finished');
                                        setReportData(prev => ({
                                            ...prev,
                                            endTime: reportData.report.end_time,
                                            totalWorkTime: reportData.report.total_work_minutes,
                                            totalPauseTime: reportData.report.lunch_minutes,
                                            approximateDistance: reportData.report.approximate_distance_meters
                                        }));
                                        storageService.clearFormData();
                                        showToast('El recorrido anterior ya había sido finalizado correctamente.', 'success');
                                    } else {
                                        showToast(`Recuperados: ${backendMaintenancePoints.length} segmentos y ${backendUnrealizablePoints.length} puntos no realizables`, 'info');
                                    }
                                }
                            }
                        } catch (error) {
                            console.error('Error recuperando datos del backend:', error);
                        }
                    }
                } catch (error) {
                    console.error('Error loading saved data:', error);
                    storageService.clearFormData();
                }
            }

            // Consultar si hay un recorrido activo en el servidor
            try {
                const token = (typeof window !== 'undefined' && window.localStorage) ? localStorage.getItem('control_campo_token') : null;
                if (token) {
                    const activeRouteRes = await fetch(`${API_BASE_URL}/simple-reports/active-route`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (activeRouteRes.ok) {
                        const data = await activeRouteRes.json();
                        setHasActiveRouteFromServer(data.has_active_route);
                    }
                }
            } catch (error) {
                console.error('Error fetching active route:', error);
            }
        };

        loadUserData();
    }, []);

    // ===== 🆕 VALIDACIÓN DE FECHA DE RECORRIDO =====
    useEffect(() => {
        const checkReportDateMismatch = () => {
            // Solo validar si hay un recorrido activo
            if (formState !== 'active' && formState !== 'lunch') return;
            if (!reportData.startTime) return;

            try {
                const reportStartDate = new Date(reportData.startTime);
                const today = new Date();

                const reportDateStr = reportStartDate.toDateString();
                const todayDateStr = today.toDateString();

                if (reportDateStr !== todayDateStr) {
                    const diffTime = today.getTime() - reportStartDate.getTime();
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                    // ✅ SOLO MOSTRAR ALERT LA PRIMERA VEZ
                    if (!sessionStorage.getItem('date-warning-shown')) {
                        alert(
                            `⚠️ ATENCIÓN: RECORRIDO DE OTRO DÍA\n\n` +
                            `📅 Tu recorrido activo es del: ${reportStartDate.toLocaleDateString('es-MX', {
                                weekday: 'long',
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            })}\n\n` +
                            `📅 Hoy es: ${today.toLocaleDateString('es-MX', {
                                weekday: 'long',
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            })}\n\n` +
                            `⏰ Han pasado: ${diffDays} día(s)\n\n` +
                            `🔴 PROBLEMA: Todos los segmentos que envíes se guardarán en el recorrido antiguo.\n\n` +
                            `⚠️ Verás un BANNER ROJO en pantalla que no desaparecerá hasta que finalices ese recorrido.\n\n` +
                            `DEBES FINALIZAR el recorrido viejo antes de continuar trabajando.`
                        );
                        sessionStorage.setItem('date-warning-shown', 'true');
                    }

                    // Toast recordatorio cada 5 minutos
                    showToast(
                        `⚠️ Tienes un recorrido del ${reportStartDate.toLocaleDateString('es-MX')} sin cerrar`,
                        'warning'
                    );
                } else {
                    // Si las fechas coinciden, limpiar el flag
                    sessionStorage.removeItem('date-warning-shown');
                }
            } catch (error) {
                console.error('Error validando fecha de recorrido:', error);
            }
        };

        // Validar inmediatamente al montar
        checkReportDateMismatch();

        // Validar cada 5 minutos (300000 ms)
        const interval = setInterval(checkReportDateMismatch, 300000);

        return () => clearInterval(interval);
    }, [formState, reportData.startTime]);


    // Guardar datos cuando cambien - OPTIMIZADO
    useEffect(() => {
        if (formState !== 'initial') {
            saveToLocalStorage();

            // Solo marcar como no guardados si hay datos realmente pendientes
            const hasPending = currentPoint !== null ||
                reportData.maintenancePoints.some(p => !p.submitted) ||
                reportData.unrealizablePoints.some(p => !p.submitted);
            setHasUnsavedData(hasPending);
        }

    }, [formState, currentPoint, reportData.maintenancePoints, reportData.unrealizablePoints, saveToLocalStorage]);

    useEffect(() => {
        if (!loading && user && reportId && isOnline) {
            checkLunchStatus();
        }
    }, [loading, user, reportId, isOnline]);


    const handleLogout = async () => {
        const confirmExit = window.confirm('¿Estás seguro que quieres salir?');
        if (!confirmExit) return;

        const hasPendingData = currentPoint !== null ||
            reportData.maintenancePoints.some(p => !p.submitted) ||
            reportData.unrealizablePoints.some(p => !p.submitted);

        if (hasPendingData) {
            const confirmWithPending = window.confirm('Hay datos sin guardar que se perderán. ¿Continuar saliendo?');
            if (!confirmWithPending) return;
        }

        localStorage.removeItem('control_campo_token');
        localStorage.removeItem('control_campo_user');
        await storageService.clearFormData();
        window.location.href = '/login';
    };

    const handleAdminPanel = () => {
        alert('Navegando al panel de administración');
    };

    // 📱 Consulta silenciosa del estado de seguridad del dispositivo (solo en Capacitor/TWA)
    // En web/PWA retorna siempre is_capacitor: false sin ningún efecto visible al usuario
    const checkNativeDeviceStatus = async () => {
        try {
            if (
                window.Capacitor &&
                window.Capacitor.Plugins &&
                window.Capacitor.Plugins.DeviceStatusPlugin
            ) {
                const result = await window.Capacitor.Plugins.DeviceStatusPlugin.checkStatus();
                return {
                    is_capacitor: true,
                    is_dev_mode: !!result.isDevMode,
                    is_mock_location_active: !!result.isMockLocation
                };
            }
        } catch (e) {
            console.warn('📱 DeviceStatusPlugin no disponible o error al consultar:', e.message);
            // Si falla el plugin (versión inicial sin plugin), reportar que sí es Capacitor pero sin datos
            if (window.Capacitor) {
                return { is_capacitor: true, is_dev_mode: false, is_mock_location_active: false };
            }
        }
        // PWA convencional / navegador web
        return { is_capacitor: false, is_dev_mode: false, is_mock_location_active: false };
    };

    const getCurrentLocation = () => {
        return new Promise((resolve, reject) => {
            // Protección máxima: si en 12 segundos el GPS no responde, abortamos para no colgar la app
            const timeoutFallback = setTimeout(() => {
                reject(new Error('Timeout de GPS tras 12 segundos.'));
            }, 12000);
            // SI HAY UBICACIÓN SIMULADA Y ESTAMOS EN STAGING/DEV, USARLA SIEMPRE
            if (isSimulatorEnabled && simulatedLocation) {
                console.log('🎮 Usando ubicación simulada:', simulatedLocation);
                clearTimeout(timeoutFallback);
                resolve({
                    ...simulatedLocation,
                    timestamp: new Date().toISOString()
                });
                return;
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        clearTimeout(timeoutFallback);
                        const loc = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                            timestamp: new Date().toISOString(),
                            is_mocked: false
                        };
                        // Sincronizar simulador con GPS real si funciona la primera vez
                        if (isSimulatorEnabled && !simulatedLocation) setSimulatedLocation(loc);
                        resolve(loc);
                    },
                    (error) => {
                        clearTimeout(timeoutFallback);
                        // Si falla GPS (como en HTTP), usar mock en staging
                        if (isSimulatorEnabled) {
                            console.warn('⚠️ GPS no disponible o bloqueado por HTTP, usando simulador');
                            const mockLoc = simulatedLocation || {
                                latitude: 25.686667,
                                longitude: -100.316667,
                                timestamp: new Date().toISOString()
                            };
                            if (!simulatedLocation) setSimulatedLocation(mockLoc);
                            resolve(mockLoc);
                        } else {
                            reject(error);
                        }
                    },
                    { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
                );
            } else {
                clearTimeout(timeoutFallback);
                if (isSimulatorEnabled) {
                    const mockLoc = simulatedLocation || {
                        latitude: 25.686667,
                        longitude: -100.316667,
                        timestamp: new Date().toISOString()
                    };
                    resolve(mockLoc);
                } else {
                    reject(new Error('Geolocalización no soportada'));
                }
            }
        });
    };

    const startRoute = async () => {
        await withLoading('startRoute', async () => {
            console.log('🚀 Iniciando recorrido con soporte offline');
            try {
                const startLocation = await getCurrentLocation();

                if (!isOnline) {
                    // Modo offline - crear reporte local
                    const tempOfflineId = Date.now();
                    setReportData(prev => ({
                        ...prev,
                        startLocation,
                        startTime: getSimulatedDate().toISOString()
                    }));
                    setOfflineReportId(tempOfflineId);
                    setFormState('active');
                    setHasUnsavedData(false);
                    showToast('Recorrido iniciado en modo offline', 'warning');
                    return;
                }

                const token = localStorage.getItem("control_campo_token");
                const formData = new FormData();
                formData.append('start_lat', startLocation.latitude.toString());
                formData.append('start_lng', startLocation.longitude.toString());

                // 📱 Consulta silenciosa del estado del dispositivo (no bloquea ni alerta al usuario)
                const deviceStatus = await checkNativeDeviceStatus();
                formData.append('is_capacitor', deviceStatus.is_capacitor.toString());
                formData.append('is_dev_mode', deviceStatus.is_dev_mode.toString());
                formData.append('is_mock_location_active', deviceStatus.is_mock_location_active.toString());

                // Enviar tiempo simulado si el simulador está activo
                if (isSimulatorEnabled && simulatedTimeOffsetMinutes !== 0) {
                    formData.append('simulated_start_time', getSimulatedDate().toISOString());
                }

                // Si hay un ID offline, enviarlo para que el servidor lo reconozca
                if (offlineReportId) {
                    formData.append('offline_id', offlineReportId.toString());
                }

                const response = await fetch(`${API_BASE_URL}/simple-reports/start-route`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });

                const data = await response.json();

                if (data.success) {
                    setReportData(prev => ({
                        ...prev,
                        startLocation,
                        startTime: data.start_time
                    }));
                    setReportId(data.report_id);
                    setOfflineReportId(null); // Limpiar ID offline
                    setFormState('active');
                    setHasUnsavedData(false);
                    setForceUpdate(prev => prev + 1);

                    if (data.existing_report) {
                        showToast('Recorrido existente recuperado', 'warning');
                        // Recuperar datos en segundo plano
                        setTimeout(async () => {
                            try {
                                const response = await fetch(`${API_BASE_URL}/simple-reports/report/${data.report_id}`, {
                                    headers: { 'Authorization': `Bearer ${token}` }
                                });

                                if (response.ok) {
                                    const reportData = await response.json();
                                    if (reportData.success) {
                                        const backendMaintenancePoints = reportData.segments.map(segment => ({
                                            id: segment.id,
                                            location: {
                                                latitude: parseFloat(segment.latitude),
                                                longitude: parseFloat(segment.longitude)
                                            },
                                            photos: {
                                                segment1: segment.photo1_path,
                                                segment2: segment.photo2_path
                                            },
                                            timestamp: segment.created_at || segment.submitted_at,
                                            submitted: true,
                                            submittedAt: segment.submitted_at
                                        }));

                                        const backendUnrealizablePoints = reportData.unrealizable_points.map(point => ({
                                            id: point.id,
                                            location: {
                                                latitude: parseFloat(point.latitude),
                                                longitude: parseFloat(point.longitude)
                                            },
                                            reason: point.reason,
                                            comments: point.comments,
                                            evidencePhoto: point.evidence_photo_path,
                                            timestamp: point.created_at || point.submitted_at,
                                            submitted: true,
                                            submittedAt: point.submitted_at,
                                            type: 'unrealizable'
                                        }));

                                        // Combinar datos locales con datos del backend - con de-duplicación por timestamp robusta
                                        const isSameTime = (t1, t2) => {
                                            if (!t1 || !t2) return false;
                                            try {
                                                const d1 = new Date(t1).getTime();
                                                const d2 = new Date(t2).getTime();
                                                return !isNaN(d1) && !isNaN(d2) && Math.abs(d1 - d2) < 5000;
                                            } catch (e) {
                                                return t1 === t2;
                                            }
                                        };

                                        setReportData(prev => {
                                            const currentServerId = reportData?.report?.id || null;
                                            const unsubmittedLocalMaintenance = prev.maintenancePoints.filter(p => {
                                                if (p.submitted) return false;
                                                return !backendMaintenancePoints.some(bp => isSameTime(bp.timestamp, p.timestamp));
                                            }).map(p => ({
                                                ...p,
                                                reportId: currentServerId || p.reportId
                                            }));

                                            const unsubmittedLocalUnrealizable = prev.unrealizablePoints.filter(p => {
                                                if (p.submitted) return false;
                                                return !backendUnrealizablePoints.some(bp => isSameTime(bp.timestamp, p.timestamp));
                                            }).map(p => ({
                                                ...p,
                                                reportId: currentServerId || p.reportId
                                            }));

                                            return {
                                                ...prev,
                                                startTime: reportData.report.start_time,
                                                startLocation: reportData.report.start_latitude ? {
                                                    latitude: parseFloat(reportData.report.start_latitude),
                                                    longitude: parseFloat(reportData.report.start_longitude)
                                                } : prev.startLocation,
                                                endLocation: reportData.report.end_latitude ? {
                                                    latitude: parseFloat(reportData.report.end_latitude),
                                                    longitude: parseFloat(reportData.report.end_longitude)
                                                } : prev.endLocation,
                                                maintenancePoints: [
                                                    ...unsubmittedLocalMaintenance,
                                                    ...backendMaintenancePoints
                                                ],
                                                unrealizablePoints: [
                                                    ...unsubmittedLocalUnrealizable,
                                                    ...backendUnrealizablePoints
                                                ]
                                            };
                                        });

                                        setForceUpdate(prev => prev + 1);
                                        showToast(`Recuperados: ${backendMaintenancePoints.length} segmentos y ${backendUnrealizablePoints.length} puntos no realizables`, 'info');
                                    }
                                }
                            } catch (error) {
                                console.error('Error recuperando puntos:', error);
                            }
                        }, 100);
                    } else {
                        showToast('Recorrido iniciado correctamente', 'success');
                    }
                } else {
                    throw new Error(data.detail || 'Error del servidor');
                }
            } catch (error) {
                console.error('Error starting route:', error);
                showToast('Error al iniciar el recorrido', 'error');
            }
        });
    };

    const addSegmentReport = async () => {
        if (currentPoint !== null) {
            showToast('Envía o cierra el punto antes de seleccionar otro', 'warning');
            return;
        }

        const pendingUnrealizable = reportData.unrealizablePoints.find(p => !p.submitted && !p.offline);
        if (pendingUnrealizable) {
            showToast('Envía o cierra el punto antes de seleccionar otro', 'warning');
            return;
        }

        const pendingOfflineSegments = (reportData.maintenancePoints || []).filter(p => !p.submitted).length;
        const pendingOfflineUnrealizables = (reportData.unrealizablePoints || []).filter(p => !p.submitted).length;
        if (pendingOfflineSegments + pendingOfflineUnrealizables >= 3) {
            showToast('Límite de 3 segmentos offline alcanzado. Sincroniza tus datos pendientes antes de agregar más.', 'error');
            return;
        }

        try {
            const location = await getCurrentLocation();

            // Candado de distancia
            let lastPointLoc = null;
            if (reportData.maintenancePoints.length > 0) {
                lastPointLoc = reportData.maintenancePoints[reportData.maintenancePoints.length - 1].location;
            } else if (reportData.startLocation) {
                lastPointLoc = reportData.startLocation;
            }

            if (lastPointLoc) {
                const distancia = calcularDistancia(lastPointLoc.latitude, lastPointLoc.longitude, location.latitude, location.longitude);
                if (distancia < 5) {
                    const confirm = window.confirm(`⚠️ ADVERTENCIA: Estás marcando este segmento a solo ${distancia.toFixed(1)} metros del punto anterior.\n\nParece que tu GPS no ha detectado movimiento o sigues en el mismo lugar.\n\n¿Estás completamente seguro de registrar el segmento aquí?`);
                    if (!confirm) return;
                }
            }

            const newPoint = {
                id: Date.now(),
                location,
                photos: { segment1: null, segment2: null },
                originalMetadata: { segment1: null, segment2: null },
                timestamp: getSimulatedDate().toISOString(), // Use simulated date
                submitted: false
            };

            setCurrentPoint(newPoint);
            setForceUpdate(prev => prev + 1);
        } catch (error) {
            console.error('Error al obtener ubicación:', error);
            window.alert('❌ ERROR AL OBTENER UBICACIÓN\n\nPor favor, verifica que tu GPS (Ubicación) esté ENCENDIDO y que la aplicación tenga permisos para acceder a él.');
            showToast('Error al obtener ubicación del punto', 'error');
        }
    };

    const addUnrealizablePoint = async () => {
        if (currentPoint !== null) {
            showToast('Envía o cierra el punto antes de seleccionar otro', 'warning');
            return;
        }

        const pendingUnrealizable = reportData.unrealizablePoints.find(p => !p.submitted && !p.offline);
        if (pendingUnrealizable) {
            showToast('Envía o cierra el punto antes de seleccionar otro', 'warning');
            return;
        }

        const pendingOfflineSegments = (reportData.maintenancePoints || []).filter(p => !p.submitted).length;
        const pendingOfflineUnrealizables = (reportData.unrealizablePoints || []).filter(p => !p.submitted).length;
        if (pendingOfflineSegments + pendingOfflineUnrealizables >= 3) {
            showToast('Límite de 3 segmentos offline alcanzado. Sincroniza tus datos pendientes antes de agregar más.', 'error');
            return;
        }

        try {
            const location = await getCurrentLocation();

            // Candado de distancia
            let lastPointLoc = null;
            if (reportData.unrealizablePoints.length > 0) {
                lastPointLoc = reportData.unrealizablePoints[reportData.unrealizablePoints.length - 1].location;
            } else if (reportData.maintenancePoints.length > 0) {
                lastPointLoc = reportData.maintenancePoints[reportData.maintenancePoints.length - 1].location;
            } else if (reportData.startLocation) {
                lastPointLoc = reportData.startLocation;
            }

            if (lastPointLoc) {
                const distancia = calcularDistancia(lastPointLoc.latitude, lastPointLoc.longitude, location.latitude, location.longitude);
                if (distancia < 5) {
                    const confirm = window.confirm(`⚠️ ADVERTENCIA: Estás marcando este punto a solo ${distancia.toFixed(1)} metros del punto anterior.\n\nParece que tu GPS no ha detectado movimiento o sigues en el mismo lugar.\n\n¿Estás completamente seguro de registrar este punto no realizable aquí?`);
                    if (!confirm) return;
                }
            }

            const newPoint = {
                id: Date.now(),
                location,
                reason: '',
                comments: '',
                evidencePhoto: null,
                timestamp: getSimulatedDate().toISOString(), // Use simulated date
                type: 'unrealizable',
                submitted: false
            };

            setReportData(prev => ({
                ...prev,
                unrealizablePoints: [...prev.unrealizablePoints, newPoint]
            }));

            setForceUpdate(prev => prev + 1);
            showToast('Ubicación del punto no realizable capturada', 'warning');
        } catch (error) {
            console.error('Error al obtener ubicación:', error);
            window.alert('❌ ERROR AL OBTENER UBICACIÓN\n\nPor favor, verifica que tu GPS (Ubicación) esté ENCENDIDO y que la aplicación tenga permisos para acceder a él.');
            showToast('Error al obtener ubicación del punto', 'error');
        }
    };

    const updatePhotoInCurrentPoint = async (photoType, file, isCamera = false) => {
        if (!file) return;

        // Validar si es la misma foto que la otra sección (segment1 vs segment2)
        const otherPhotoType = photoType === 'segment1' ? 'segment2' : 'segment1';
        const otherMetadata = currentPoint?.originalMetadata?.[otherPhotoType];

        if (otherMetadata) {
            const isSameName = file.name === otherMetadata.name;
            const isSameSize = file.size === otherMetadata.size;
            const isSameTime = file.lastModified === otherMetadata.lastModified;

            if ((isSameName && isSameSize) || (isSameSize && isSameTime)) {
                window.alert('⚠️ ERROR: Estás intentando subir la misma foto para el ANTES y el DESPUÉS.\n\nDebes tomar o seleccionar fotos distintas.');
                return;
            }
        }

        try {
            const watermarkInfo = isCamera ? {
                name: user?.name || 'Técnico',
                usuario_ffm: user?.usuario_ffm || 'N/A',
                region: user?.region || 'N/A',
                district: user?.district || 'N/A',
                latitude: currentPoint?.location?.latitude || 'N/A',
                longitude: currentPoint?.location?.longitude || 'N/A',
                dateTime: getFormattedDateTime(getSimulatedDate())
            } : null;
            const compressedFile = await compressImage(file, 0.5, 1200, 1200, watermarkInfo);
            setCurrentPoint(prev => ({
                ...prev,
                photos: { ...prev.photos, [photoType]: compressedFile },
                originalMetadata: {
                    ...prev.originalMetadata,
                    [photoType]: {
                        name: file.name,
                        size: file.size,
                        lastModified: file.lastModified
                    }
                }
            }));
            setForceUpdate(prev => prev + 1);
            showToast(`Foto ${photoType === 'segment1' ? '1' : '2'} comprimida exitosamente`, 'success');
        } catch (error) {
            console.error('Error comprimiendo imagen:', error);
            showToast('Error al comprimir la imagen', 'error');
        }
    };

    const updateUnrealizablePoint = async (pointId, field, value, isCamera = false) => {
        if (field === 'evidencePhoto' && value) {
            try {
                const targetPoint = reportData.unrealizablePoints.find(p => p.id === pointId);
                const watermarkInfo = isCamera ? {
                    name: user?.name || 'Técnico',
                    usuario_ffm: user?.usuario_ffm || 'N/A',
                    region: user?.region || 'N/A',
                    district: user?.district || 'N/A',
                    latitude: targetPoint?.location?.latitude || 'N/A',
                    longitude: targetPoint?.location?.longitude || 'N/A',
                    dateTime: getFormattedDateTime(getSimulatedDate())
                } : null;
                const compressedFile = await compressImage(value, 0.5, 1200, 1200, watermarkInfo);
                setReportData(prev => ({
                    ...prev,
                    unrealizablePoints: prev.unrealizablePoints.map(point =>
                        point.id === pointId ? { ...point, [field]: compressedFile } : point
                    )
                }));
                showToast('Foto de evidencia comprimida exitosamente', 'success');
            } catch (error) {
                console.error('Error comprimiendo imagen:', error);
                showToast('Error al comprimir la imagen', 'error');
            }
        } else {
            setReportData(prev => ({
                ...prev,
                unrealizablePoints: prev.unrealizablePoints.map(point =>
                    point.id === pointId ? { ...point, [field]: value } : point
                )
            }));
        }
        setForceUpdate(prev => prev + 1);
    };

    const submitSegmentReport = async () => {
        await withLoading('submitSegment', async () => {
            if (!currentPoint) {
                console.error('❌ submitSegmentReport llamado sin currentPoint');
                return;
            }

            const { segment1, segment2 } = currentPoint.photos;
            if (!segment1 || !segment2) {
                showToast('Las 2 fotos del segmento son obligatorias', 'error');
                return;
            }

            if (!currentPoint.activities || currentPoint.activities.length === 0) {
                window.alert('⚠️ ERROR: Debes marcar al menos una actividad de mantenimiento realizada.');
                return;
            }

            // 🆕 GUARDAR COORDENADAS ANTES DE CUALQUIER OPERACIÓN
            const coordenadasOriginales = {
                lat: currentPoint.location.latitude,
                lng: currentPoint.location.longitude,
                timestamp: currentPoint.timestamp,
                id: currentPoint.id,
                is_mocked: false
            };

            // ⏱️ Momento exacto en que el técnico presionó "Enviar Reporte"
            const sentAt = getSimulatedDate().toISOString();

            console.log('🔴 INICIO submitSegmentReport:', { ...coordenadasOriginales, sentAt });

            // Función para enviar al servidor
            const sendToServer = async () => {
                const token = localStorage.getItem("control_campo_token");
                const formData = new FormData();

                const targetReportId = reportId || offlineReportId;

                // 🆕 VALIDACIÓN CRÍTICA: Verificar que las coordenadas no cambiaron
                if (currentPoint.location.latitude !== coordenadasOriginales.lat ||
                    currentPoint.location.longitude !== coordenadasOriginales.lng) {
                    console.error('🚨🚨🚨 ALERTA: Las coordenadas de currentPoint CAMBIARON durante el proceso!');
                    console.error('Original:', coordenadasOriginales);
                    console.error('Actual:', currentPoint.location);
                }

                console.log('📤 Enviando al servidor:', {
                    reportId: targetReportId,
                    lat: coordenadasOriginales.lat.toFixed(7),
                    lng: coordenadasOriginales.lng.toFixed(7),
                    timestamp_captura: coordenadasOriginales.timestamp,
                    timestamp_envio: sentAt // Use sentAt
                });

                formData.append('report_id', targetReportId.toString());
                formData.append('latitude', coordenadasOriginales.lat.toString());
                formData.append('longitude', coordenadasOriginales.lng.toString());
                formData.append('created_at', coordenadasOriginales.timestamp);
                formData.append('submitted_at', sentAt); // Use sentAt

                if (currentPoint.activities) {
                    formData.append('activities', JSON.stringify(currentPoint.activities));
                }

                // 📱 Envío silencioso del estado del dispositivo (ya calculado al inicio del recorrido)
                // No volvemos a llamar checkNativeDeviceStatus() para no retrasar el envío de fotos
                const segmentDevStatus = await checkNativeDeviceStatus();
                formData.append('is_capacitor', segmentDevStatus.is_capacitor.toString());
                formData.append('is_dev_mode', segmentDevStatus.is_dev_mode.toString());
                formData.append('is_mock_location_active', segmentDevStatus.is_mock_location_active.toString());
                formData.append('was_offline', 'false'); // 📶 Envío en vivo directo al servidor con señal

                // Asegurar que las fotos sean File/Blob aunque vengan de localStorage como base64
                const toFile = (photo, name) => {
                    if (!photo) return null;
                    if (photo instanceof Blob) return photo; // ya es File/Blob, ok
                    if (typeof photo === 'string') return deserializeFile(photo, name); // base64 → File
                    return null;
                };
                const photo1File = toFile(segment1, `segment1_${coordenadasOriginales.id}.jpg`);
                const photo2File = toFile(segment2, `segment2_${coordenadasOriginales.id}.jpg`);

                if (!photo1File || !photo2File) {
                    throw new Error('No se pudieron obtener las fotos del segmento');
                }

                formData.append('photo1', photo1File);
                formData.append('photo2', photo2File);

                const response = await fetch(`${API_BASE_URL}/simple-reports/segment-report`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });

                const data = await response.json();

                console.log('📥 Respuesta del servidor:', {
                    success: data.success,
                    segment_id: data.segment_id,
                    coordinates_saved: data.coordinates_saved,
                    coordenadas_enviadas: coordenadasOriginales
                });

                if (!data.success) {
                    throw new Error(data.detail || 'Error del servidor');
                }

                // Éxito - marcar como enviado CON COORDENADAS ORIGINALES
                const submittedPoint = {
                    ...currentPoint,
                    location: {
                        latitude: coordenadasOriginales.lat,
                        longitude: coordenadasOriginales.lng,
                        timestamp: coordenadasOriginales.timestamp
                    },
                    photos: { segment1: null, segment2: null },
                    submitted: true,
                    sentAt,           // ⏱️ momento en que presionó Enviar
                    submittedAt: sentAt // Use sentAt
                };

                setReportData(prev => ({
                    ...prev,
                    maintenancePoints: [...prev.maintenancePoints, {
                        ...submittedPoint,
                        id: data.segment_id || submittedPoint.id
                    }]
                }));

                setCurrentPoint(null);
                console.log('✅ currentPoint limpiado después de envío exitoso');
                setHasUnsavedData(false);
                setForceUpdate(prev => prev + 1);
            };

            // Función de fallback para guardar offline
            const saveOffline = async () => {
                console.log('💾 Guardando offline con coordenadas:', coordenadasOriginales);

                const submittedPoint = {
                    ...currentPoint,
                    location: {
                        latitude: coordenadasOriginales.lat,
                        longitude: coordenadasOriginales.lng,
                        timestamp: coordenadasOriginales.timestamp
                    },
                    submitted: false,
                    sentAt,           // ⏱️ momento en que presionó Enviar (se conserva aunque sincronice después)
                    submittedAt: null,
                    offline: true,
                    was_offline: true,
                    reportId: reportId || offlineReportId  // 🆕 guardar a qué reporte pertenece
                };

                setReportData(prev => ({
                    ...prev,
                    maintenancePoints: [...prev.maintenancePoints, submittedPoint]
                }));

                setCurrentPoint(null);
                console.log('✅ currentPoint limpiado después de guardar offline');
                setForceUpdate(prev => prev + 1);
            };

            try {
                if (!navigator.onLine) {
                    // Si el navegador reporta explícitamente estar sin red, guardar directamente offline
                    await saveOffline();
                    showToast('Reporte guardado localmente. Se enviará cuando haya conexión.', 'warning');
                } else {
                    // Si hay red (4G/WiFi), intentar siempre el envío online con timeout
                    await submitWithTimeout(sendToServer, saveOffline, 90000, 'Reporte de segmento');
                }
            } catch (error) {
                console.error('Error en submitSegmentReport:', error);
                showToast('Error inesperado al procesar el reporte', 'error');
            }
        });
    };

    const submitUnrealizablePoint = async (pointId) => {
        await withLoading(`unrealizable-${pointId}`, async () => {
            const point = reportData.unrealizablePoints.find(p => p.id === pointId);
            if (!point || !point.reason || !point.comments.trim() || !point.evidencePhoto) {
                showToast('Completa todos los campos del punto no realizable', 'error');
                return;
            }

            // ⏱️ Momento exacto en que el técnico presionó "Enviar Justificación"
            const sentAt = getSimulatedDate().toISOString();

            // Función para enviar al servidor
            const sendToServer = async () => {
                const token = localStorage.getItem("control_campo_token");
                const formData = new FormData();

                const targetReportId = reportId || offlineReportId;
                formData.append('report_id', targetReportId.toString());
                formData.append('latitude', point.location.latitude.toString());
                formData.append('longitude', point.location.longitude.toString());
                formData.append('reason', point.reason);
                formData.append('comments', point.comments);
                formData.append('created_at', point.timestamp);
                formData.append('submitted_at', new Date().toISOString());
                formData.append('was_offline', 'false'); // 📶 Envío en vivo directo al servidor con señal
                formData.append('evidence_photo', point.evidencePhoto);

                const response = await fetch(`${API_BASE_URL}/simple-reports/unrealizable-point`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });

                const data = await response.json();
                if (!data.success) {
                    throw new Error(data.detail || 'Error del servidor');
                }

                // Éxito - marcar como enviado
                setReportData(prev => ({
                    ...prev,
                    unrealizablePoints: prev.unrealizablePoints.map(p =>
                        p.id === pointId
                            ? { ...p, evidencePhoto: null, submitted: true, sentAt, submittedAt: new Date().toISOString() }
                            : p
                    )
                }));

                setHasUnsavedData(false);
                setForceUpdate(prev => prev + 1);
            };

            // Función de fallback para guardar offline
            const saveOffline = async () => {
                setReportData(prev => ({
                    ...prev,
                    unrealizablePoints: prev.unrealizablePoints.map(p =>
                        p.id === pointId
                            ? { ...p, submitted: false, sentAt, submittedAt: null, offline: true, was_offline: true, reportId: reportId || offlineReportId }
                            : p
                    )
                }));
                setForceUpdate(prev => prev + 1);
            };

            try {
                if (!navigator.onLine) {
                    // Si el navegador reporta sin red, guardar directamente offline
                    await saveOffline();
                    showToast('Punto guardado localmente. Se enviará cuando haya conexión.', 'warning');
                } else {
                    // Intentar envío online con timeout
                    await submitWithTimeout(sendToServer, saveOffline, 90000, 'Punto no realizable');
                }
            } catch (error) {
                console.error('Error en submitUnrealizablePoint:', error);
                showToast('Error inesperado al procesar el punto', 'error');
            }
        });
    };

    const deleteUnrealizablePoint = (pointId) => {
        if (window.confirm('¿Eliminar este punto no realizable?')) {
            setReportData(prev => ({
                ...prev,
                unrealizablePoints: prev.unrealizablePoints.filter(p => p.id !== pointId)
            }));
            setForceUpdate(prev => prev + 1);
            showToast('Punto eliminado', 'success');
        }
    };

    const goToLunch = async () => {
        await withLoading('goToLunch', async () => {
            try {
                const token = localStorage.getItem("control_campo_token");
                const targetReportId = reportId || offlineReportId;

                if (isOnline && targetReportId) {
                    // Enviar pausa al servidor
                    const formData = new FormData();
                    formData.append('report_id', targetReportId.toString());

                    const response = await fetch(`${API_BASE_URL}/simple-reports/go-to-lunch`, {
                        method: 'POST',
                        headers: { 'Authorization': `Bearer ${token}` },
                        body: formData
                    });

                    const data = await response.json();
                    if (!data.success) throw new Error(data.message);

                    // Usar la hora del servidor
                    setPauseStartTime(data.lunch_start_time);
                } else {
                    // Modo offline
                    setPauseStartTime(new Date().toISOString());
                }

                // Actualizar estado local
                setIsPaused(true);
                setFormState('lunch');
                setForceUpdate(prev => prev + 1);

                // Guardar en localStorage
                saveToLocalStorage();

                showToast('Tiempo pausado - Disfruta tu comida', 'warning');

            } catch (error) {
                console.error('Error pausando para comida:', error);
                // Fallback offline
                setIsPaused(true);
                setPauseStartTime(new Date().toISOString());
                setFormState('lunch');
                showToast('Modo comida iniciado (offline)', 'warning');
            }
        });
    };

    const resumeFromLunch = async () => {
        await withLoading('resumeFromLunch', async () => {
            try {
                const token = localStorage.getItem("control_campo_token");
                const targetReportId = reportId || offlineReportId;
                let lunchMinutes = 0;

                // Calcular minutos offline primero
                if (pauseStartTime) {
                    const pauseDuration = new Date().getTime() - new Date(pauseStartTime).getTime();
                    lunchMinutes = Math.round(pauseDuration / (1000 * 60));
                }

                if (isOnline && targetReportId) {
                    // Enviar reanudación al servidor
                    const formData = new FormData();
                    formData.append('report_id', targetReportId.toString());

                    const response = await fetch(`${process.env.REACT_APP_API_URL}/simple-reports/resume-from-lunch`, {
                        method: 'POST',
                        headers: { 'Authorization': `Bearer ${token}` },
                        body: formData
                    });

                    const data = await response.json();
                    if (!data.success) throw new Error(data.message);

                    // Usar el tiempo calculado por el servidor
                    lunchMinutes = data.lunch_minutes;
                }

                // Actualizar tiempo total
                setTotalPauseTime(prev => prev + (lunchMinutes * 60 * 1000));

                // Actualizar estado local
                setIsPaused(false);
                setPauseStartTime(null);
                setFormState('active');
                setForceUpdate(prev => prev + 1);

                // Guardar en localStorage
                saveToLocalStorage();

                showToast(`Recorrido reanudado después de ${lunchMinutes} minutos de comida`, 'success');

            } catch (error) {
                console.error('Error reanudando de comida:', error);
                // Fallback offline
                if (pauseStartTime) {
                    const pauseDuration = new Date().getTime() - new Date(pauseStartTime).getTime();
                    setTotalPauseTime(prev => prev + pauseDuration);
                }
                setIsPaused(false);
                setPauseStartTime(null);
                setFormState('active');
                showToast('Recorrido reanudado (offline)', 'success');
            }
        });
    };

    const finishRoute = async () => {
        // Validación dura: sin internet no se puede finalizar
        if (!isOnline) {
            showToast('❌ Necesitas conexión a internet para finalizar el recorrido.', 'error');
            return;
        }

        // Validación dura: no se puede finalizar con segmentos offline pendientes
        const pendingSegments = (reportData.maintenancePoints || []).filter(p => !p.submitted).length;
        const pendingUnrealizables = (reportData.unrealizablePoints || []).filter(p => !p.submitted).length;
        if (pendingSegments + pendingUnrealizables > 0) {
            showToast(`❌ Tienes ${pendingSegments + pendingUnrealizables} segmento(s) sin sincronizar. Presiona "Sincronizar" antes de finalizar.`, 'error');
            return;
        }

        const hasSubmittedPoints = reportData.maintenancePoints.length > 0 || reportData.unrealizablePoints.some(p => p.submitted || p.offline);
        if (!hasSubmittedPoints) {
            if (!window.confirm("¿Quieres finalizar tu recorrido sin registrar segmentos? El recorrido será cancelado y su ID quedará liberado.")) {
                return;
            }
        } else {
            if (!window.confirm("¿Estás seguro de finalizar el recorrido? Esta acción calculará tus tiempos y distancia aproximada.")) {
                return;
            }
        }

        await withLoading('finishRoute', async () => {
            try {
                const endLocation = await getCurrentLocation();

                // Calcular tiempo trabajado
                let totalWorkTime = 0;
                if (reportData.startTime) {
                    const startTime = new Date(reportData.startTime);
                    const endTimeDate = new Date();
                    const totalTimeMs = Math.max(0, endTimeDate.getTime() - startTime.getTime());
                    let totalTimeMinutes = Math.round(totalTimeMs / (1000 * 60));

                    let totalPauseTimeMs = totalPauseTime;
                    if (isPaused && pauseStartTime) {
                        const currentPauseMs = new Date().getTime() - new Date(pauseStartTime).getTime();
                        totalPauseTimeMs += currentPauseMs;
                    }

                    const totalPauseMinutes = Math.round(totalPauseTimeMs / (1000 * 60));
                    totalWorkTime = Math.max(0, totalTimeMinutes - totalPauseMinutes);
                    totalWorkTime = Math.max(0, Math.min(totalWorkTime, 1440)); // Máximo 24 horas
                }

                // A partir de aquí siempre hay internet y todos los segmentos están en el servidor

                // Modo online - enviar inmediatamente
                const token = localStorage.getItem("control_campo_token");
                const formData = new FormData();

                // Usar el ID correcto (servidor u offline)
                const targetReportId = reportId || offlineReportId;
                formData.append('report_id', targetReportId.toString());
                formData.append('end_lat', endLocation.latitude.toString());
                formData.append('end_lng', endLocation.longitude.toString());
                formData.append('total_work_minutes', totalWorkTime.toString());

                // Enviar tiempo simulado si el simulador está activo
                if (isSimulatorEnabled && simulatedTimeOffsetMinutes !== 0) {
                    formData.append('simulated_end_time', getSimulatedDate().toISOString());
                }

                // Si estamos usando un ID offline, informar al servidor
                if (offlineReportId) {
                    formData.append('offline_id', offlineReportId.toString());
                }

                const response = await fetch(`${API_BASE_URL}/simple-reports/finish-route`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` },
                    body: formData
                });

                const data = await response.json();

                if (data.success) {
                    if (data.cancelled) {
                        showToast(data.message || 'Recorrido cancelado por falta de segmentos.', 'info');
                        await storageService.clearFormData();
                        localStorage.removeItem('control_campo_token');
                        localStorage.removeItem('control_campo_user');
                        window.location.href = '/login';
                        return;
                    }
                    let approximateDistance = 0;
                    if (data.statistics?.approximate_distance_meters) {
                        approximateDistance = data.statistics.approximate_distance_meters;
                    } else if (reportData.startLocation && endLocation) {
                        const distance = calculateDistance(
                            reportData.startLocation.latitude,
                            reportData.startLocation.longitude,
                            endLocation.latitude,
                            endLocation.longitude
                        );
                        approximateDistance = Math.round(distance * 1000);
                    }

                    const finalReport = {
                        ...reportData,
                        endLocation,
                        endTime: data.completed_at || new Date().toISOString(),
                        approximateDistance: approximateDistance,
                        totalWorkTime: data.statistics?.total_work_minutes || totalWorkTime,
                        totalPauseTime: data.statistics?.lunch_minutes || Math.round((totalPauseTime + (isPaused && pauseStartTime ? new Date().getTime() - new Date(pauseStartTime).getTime() : 0)) / (1000 * 60)),
                        tiempoDesfasado: data.tiempoDesfasado || false,  // ← NUEVO
                        razonDesfase: data.razonDesfase,                 // ← NUEVO
                        segmentosDesfasados: data.segmentosDesfasados,   // ← NUEVO
                        diferenciaPromedio: data.diferenciaPromedio,     // ← NUEVO
                        inactividad: data.inactividad || null           // ← NUEVO: Consigna 2 horas
                    };

                    setReportData(finalReport);
                    setFormState('finished');
                    setIsPaused(false);
                    setPauseStartTime(null);
                    setOfflineReportId(null);
                    storageService.clearFormData();
                    setHasUnsavedData(false);
                    setForceUpdate(prev => prev + 1);

                    // 🚨 MOSTRAR ALERTA DE DESFASE SI APLICA
                    if (data.tiempoDesfasado) {
                        showToast(`⚠️ TIEMPO SOSPECHOSO - Este reporte entrará a AUDITORÍA. ${data.razonDesfase}`, 'warning');
                    } else {
                        showToast('Recorrido finalizado y enviado correctamente', 'success');
                    }
                } else {
                    throw new Error(data.detail || data.message || 'Error del servidor');
                }
            } catch (error) {
                console.error('Error al finalizar recorrido:', error);
                showToast('Error al finalizar el recorrido: ' + error.message, 'error');
            }
        });
    };

    // ===== TIEMPO OPERATIVO EFECTIVO =====
    // Calcula el tiempo desde que se envió el PRIMER punto (segmento o no realizable)
    // hasta que se envió el ÚLTIMO punto, usando sentAt (momento en que presionaron Enviar).
    // Fallback: submittedAt → timestamp (para datos anteriores sin sentAt).
    // Si hay 0 o 1 punto en total → retorna 0.
    const getSentTime = (p) => {
        // sentAt  = momento exacto en que el técnico presionó Enviar ✅
        // submittedAt = cuando llegó al servidor (puede ser sincronización tardía) ⚠️
        // timestamp = cuando abrió el formulario del punto ❌ (ya no se usa)
        const raw = p.sentAt || p.submittedAt || p.timestamp;
        if (!raw) return NaN;
        const t = new Date(raw).getTime();
        return isNaN(t) ? NaN : t;
    };

    const calcularMetricasAdherencia = (data) => {

        const getSentRaw = (p) => p.sentAt || p.submittedAt || p.timestamp;

        // 1. Obtener todos los puntos (segmentos y no realizables) ordenados por tiempo
        const segmentos = data.maintenancePoints
            .filter(p => p.submitted || p.offline)
            .map(p => ({ ts: new Date(getSentRaw(p)).getTime(), loc: p.location }));

        const noRealizables = data.unrealizablePoints
            .filter(p => p.submitted || p.offline)
            .map(p => ({ ts: new Date(getSentRaw(p)).getTime(), loc: p.location }));

        const todos = [...segmentos, ...noRealizables]
            .filter(p => !isNaN(p.ts))
            .sort((a, b) => a.ts - b.ts);

        if (todos.length === 0) return { tiempoTrabajado: 0, tiempoOperativoEfectivo: 0, distInicioAFrimero: 0, aplicaPenalizacion: false, escenario: 'A' };

        const tiempoTrabajado = data.totalWorkTime || 0;
        const getDayStr = (ts) => {
            const d = new Date(ts);
            return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
        };

        const primerPuntoGlobal = todos[0];
        const fechaInicio = data.startTime ? new Date(data.startTime) : null;
        const diaInicio = fechaInicio ? getDayStr(fechaInicio.getTime()) : null;
        const diaPrimerPunto = getDayStr(primerPuntoGlobal.ts);

        const isDifferentDayLogin = diaInicio && diaInicio !== diaPrimerPunto;
        const validTodos = todos.filter(p => getDayStr(p.ts) === diaPrimerPunto);
        const validPrimerPunto = validTodos[0];
        const validUltimoPunto = validTodos[validTodos.length - 1];

        let distInicioAFrimero = 0;
        let aplicaPenalizacion = false;
        let tiempoOperativoBruto = 0;
        let escenario = 'A';

        // ============================================
        // LÓGICA UNIFICADA DE TIEMPO OPERATIVO EFECTIVO
        // (Debe coincidir con el cálculo del backend en finish-route)
        // ============================================
        // REGLA DE INICIO (desde dónde contar):
        //   - Si login de otro día (escenario D) → desde primer segmento
        //   - Si dist(inicio → primer segmento) < 500m → desde inicio del recorrido
        //   - Si dist >= 500m → desde primer segmento (penalización)
        // REGLA DE FIN (hasta dónde contar):
        //   - Si recorrido cerrado y dist(último segmento → cierre) <= 500m → hasta el cierre
        //   - En cualquier otro caso → hasta el último segmento levantado
        // ============================================

        if (isDifferentDayLogin) {
            escenario = 'D';
            aplicaPenalizacion = true;
        } else if (validTodos.length < todos.length) {
            aplicaPenalizacion = true;
            escenario = validTodos.length === 1 ? 'C' : 'B';
        }

        // Calcular distancia inicio → primer segmento
        if (data.startLocation && validPrimerPunto.loc) {
            distInicioAFrimero = calcularDistancia(
                data.startLocation.latitude, data.startLocation.longitude,
                validPrimerPunto.loc.latitude, validPrimerPunto.loc.longitude
            );
        }

        // DESDE cuándo contar
        // 🔧 FIX: Verificar SIEMPRE la regla de 500m, independientemente del desfase
        let tsDesde;
        if (isDifferentDayLogin) {
            // Si hay desfase de día, contar desde primer segmento (no podemos contar desde el día anterior)
            tsDesde = validPrimerPunto.ts;
        } else if (fechaInicio && data.startLocation && validPrimerPunto.loc && distInicioAFrimero < 500) {
            // Si distancia inicio → primer segmento < 500m → contar desde inicio del recorrido
            tsDesde = fechaInicio.getTime();
        } else {
            // Si distancia >= 500m → contar desde primer segmento (penalización por traslado)
            tsDesde = validPrimerPunto.ts;
            if (!isDifferentDayLogin && distInicioAFrimero >= 500) {
                aplicaPenalizacion = true;
            }
        }

        // HASTA cuándo contar
        let usarHasta = validUltimoPunto.ts; // Por defecto: hasta último segmento
        let distUltimoACierre = null;

        const finRecorridoTS = data.endTime ? new Date(data.endTime).getTime() : null;
        const finRecorridoLoc = data.endLocation || null;

        if (finRecorridoTS && finRecorridoLoc && validUltimoPunto.loc) {
            // Solo extender hasta el cierre si:
            // 1. El cierre es del MISMO DÍA que el último segmento
            // 2. La distancia último segmento → cierre es <= 500m
            const diaUltimoSeg = getDayStr(validUltimoPunto.ts);
            const diaCierre = getDayStr(finRecorridoTS);
            const cierreMismoDia = diaUltimoSeg === diaCierre;

            distUltimoACierre = calcularDistancia(
                validUltimoPunto.loc.latitude, validUltimoPunto.loc.longitude,
                finRecorridoLoc.latitude, finRecorridoLoc.longitude
            );
            if (cierreMismoDia && distUltimoACierre <= 500) {
                usarHasta = finRecorridoTS; // Extender hasta el cierre
            }
        }

        tiempoOperativoBruto = Math.round((usarHasta - tsDesde) / (1000 * 60));

        const minutosBreak = data.totalPauseTime || 0;
        const tiempoOperativoEfectivo = Math.max(0, tiempoOperativoBruto - minutosBreak);

        // Construir alertas de penalización
        const alertas = [];
        const penalizacionInicio = (!isDifferentDayLogin && distInicioAFrimero >= 500);
        const cierreLejos = (distUltimoACierre !== null && distUltimoACierre > 500);
        const cierreOtroDia = (finRecorridoTS && validUltimoPunto && getDayStr(finRecorridoTS) !== getDayStr(validUltimoPunto.ts));

        if (isDifferentDayLogin) {
            alertas.push({ tipo: 'sesion_desfasada', mensaje: 'Iniciaste recorrido un día diferente al de tus segmentos. Solo cuenta el tiempo desde tu primer segmento.' });
            aplicaPenalizacion = true;
        }
        if (penalizacionInicio) {
            const minDescuento = Math.round((validPrimerPunto.ts - fechaInicio.getTime()) / (1000 * 60));
            alertas.push({ tipo: 'inicio_lejos', mensaje: `Iniciaste a ${Math.round(distInicioAFrimero)}m de tu primer punto (máx 500m). Se descontaron ~${minDescuento} min de traslado.` });
            aplicaPenalizacion = true;
        }
        if (cierreOtroDia) {
            alertas.push({ tipo: 'cierre_otro_dia', mensaje: 'Cerraste el recorrido un día diferente. Solo cuenta hasta tu último segmento del día.' });
            aplicaPenalizacion = true;
        } else if (cierreLejos) {
            const minDescuento = Math.round((finRecorridoTS - validUltimoPunto.ts) / (1000 * 60));
            alertas.push({ tipo: 'cierre_lejos', mensaje: `Cerraste a ${Math.round(distUltimoACierre)}m de tu último punto (máx 500m). Se descontaron ~${minDescuento} min.` });
            aplicaPenalizacion = true;
        }

        return {
            tiempoTrabajado,
            tiempoOperativoEfectivo,
            distInicioAFrimero,
            aplicaPenalizacion,
            escenario,
            distUltimoACierre,
            alertas,
            tiempoDesfasado: false,  // ← Se actualizará cuando finalice (desde backend)
            segmentosDesfasados: 0,
            diferenciaPromedio: 0,
            metaInfo: {
                primerPuntoTS: validPrimerPunto.ts,
                ultimoPuntoTS: validUltimoPunto.ts,
                inicioRecorridoTS: fechaInicio ? fechaInicio.getTime() : null,
                finRecorridoTS,
                usarHasta
            }
        };
    };

    const calcularTiempoOperativoEfectivo = (data) => {
        const metriz = calcularMetricasAdherencia(data);
        return metriz.tiempoOperativoEfectivo;
    };

    const calcularMetricasDistancia = (data) => {
        const getSentRaw = (p) => p.sentAt || p.submittedAt || p.timestamp;

        // Unificar segmentos y puntos no realizables
        const todosLosPuntos = [
            ...data.maintenancePoints.filter(p => p.submitted || p.offline).map(p => ({ ...p, __type: 'segment' })),
            ...data.unrealizablePoints.filter(p => p.submitted || p.offline).map(p => ({ ...p, __type: 'unrealizable' }))
        ].sort((a, b) => {
            const ta = new Date(getSentRaw(a)).getTime();
            const tb = new Date(getSentRaw(b)).getTime();
            return ta - tb;
        });

        if (todosLosPuntos.length === 0) return { total: 0, filtrada: 0, alertas: [], descuentosDistancia: [] };

        let total = 0;
        let filtrada = 0;
        const alertas = [];
        const descuentosDistancia = [];
        const UMBRAL_LONG_HAUL = 150; // Metros
        const UMBRAL_INICIO = 500;    // Metros

        // 🆕 NUEVA LÓGICA: Incluir tramo desde Inicio de Jornada hasta el primer punto
        if (data.startLocation && todosLosPuntos[0].location) {
            const distInicio = calcularDistancia(
                data.startLocation.latitude, data.startLocation.longitude,
                todosLosPuntos[0].location.latitude, todosLosPuntos[0].location.longitude
            );

            if (distInicio < UMBRAL_INICIO) {
                total += distInicio;
                // El tramo inicial también pasa por el filtro de los 150m
                if (distInicio <= UMBRAL_LONG_HAUL) {
                    if (todosLosPuntos[0].__type === 'segment') {
                        filtrada += distInicio;
                    }
                } else {
                    alertas.push({
                        inicio: 'Inicio Jornada',
                        fin: 'Punto 1',
                        distancia: distInicio,
                        esInicio: true
                    });
                }
            } else {
                descuentosDistancia.push({
                    tipo: 'inicio_lejos',
                    mensaje: `Iniciaste recorrido a más de 500 metros de tu primer segmento. Se considera como traslado y no se contemplarán ${Math.round(distInicio)} m.`
                });
            }
        }

        for (let i = 1; i < todosLosPuntos.length; i++) {
            const p1 = todosLosPuntos[i - 1];
            const p2 = todosLosPuntos[i];

            if (!p1.location || !p2.location) continue;

            const d = calcularDistancia(
                p1.location.latitude, p1.location.longitude,
                p2.location.latitude, p2.location.longitude
            );

            total += d;

            if (d > UMBRAL_LONG_HAUL) {
                alertas.push({
                    inicio: i,
                    fin: i + 1,
                    distancia: d,
                    dbId1: p1.id,
                    dbId2: p2.id
                });
            } else {
                if (p2.__type === 'segment') {
                    filtrada += d;
                }
            }
        }

        // Tramo final: Último Punto -> Ubicación de Cierre (solo si el reporte está finalizado)
        if (data.endTime && data.endLocation && todosLosPuntos.length > 0) {
            const lastP = todosLosPuntos[todosLosPuntos.length - 1];
            if (lastP.location) {
                const distCierre = calcularDistancia(
                    lastP.location.latitude, lastP.location.longitude,
                    data.endLocation.latitude, data.endLocation.longitude
                );

                if (distCierre < UMBRAL_INICIO) {
                    total += distCierre;
                    if (distCierre <= UMBRAL_LONG_HAUL) {
                        filtrada += distCierre;
                    } else {
                        alertas.push({
                            inicio: 'Último Punto',
                            fin: 'Cierre Jornada',
                            distancia: distCierre,
                            esCierre: true
                        });
                    }
                } else {
                    descuentosDistancia.push({
                        tipo: 'cierre_lejos',
                        mensaje: `Y cerraste recorrido a más de 500 metros de tu último segmento enviado. Se considera como traslado y no se contemplarán ${Math.round(distCierre)} m.`
                    });
                }
            }
        }

        return { total: Math.round(total), filtrada: Math.round(filtrada), alertas, descuentosDistancia };
    };

    const formatTiempoOperativo = (minutos) => {
        if (minutos === 0) return '0 min';
        const h = Math.floor(minutos / 60);
        const m = minutos % 60;
        if (h === 0) return `${m} min`;
        if (m === 0) return `${h}h 0min`;
        return `${h}h ${m}min`;
    };

    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371; // Radio de la Tierra en km
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    const calcularDistancia = (lat1, lon1, lat2, lon2) => {
        const R = 6371000; // Radio de la Tierra en metros
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return Math.round(R * c); // Distancia en metros
    };

    const checkLunchStatus = async () => {
        if (reportId && isOnline) {
            try {
                const token = localStorage.getItem("control_campo_token");
                const response = await fetch(`${process.env.REACT_APP_API_URL}/simple-reports/${reportId}/lunch-status`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    // Si es 404, puede ser que el reporte no exista o no esté en comida
                    if (response.status === 404) {
                        console.log('Reporte no encontrado o no está en comida');
                        return;
                    }
                    throw new Error(`HTTP ${response.status}`);
                }

                const data = await response.json();

                if (data.is_in_lunch && data.lunch_start_time) {
                    // Recuperar estado de comida del servidor
                    setIsPaused(true);
                    setFormState('lunch');
                    setPauseStartTime(data.lunch_start_time);

                    // Calcular tiempo transcurrido
                    const elapsedMinutes = Math.round(
                        (new Date().getTime() - new Date(data.lunch_start_time).getTime()) / (1000 * 60)
                    );

                    showToast(`Recuperada pausa de comida de ${elapsedMinutes} minutos`, 'info');
                }
            } catch (error) {
                console.error('Error checking lunch status:', error);
                // No mostrar error al usuario, solo log
            }
        }
    };


    const prepareNewRoute = () => {
        storageService.clearFormData().catch(err => console.error('Error clearing form data in prepareNewRoute:', err));
        setFormState('initial');
        setReportId(null);
        setOfflineReportId(null);
        setCurrentPoint(null);
        setIsPaused(false);
        setPauseStartTime(null);
        setTotalPauseTime(0);
        setReportData({
            startLocation: null,
            endLocation: null,
            startTime: null,
            endTime: null,
            maintenancePoints: [],
            unrealizablePoints: []
        });
        setHasUnsavedData(false);
        setSyncStatus('idle');
        setLastSyncTime(null);
        setForceUpdate(prev => prev + 1);
    };

    const clearCorruptedData = () => {
        storageService.clearFormData();
        setReportData({
            startLocation: null,
            endLocation: null,
            startTime: null,
            endTime: null,
            maintenancePoints: [],
            unrealizablePoints: []
        });
        setFormState('initial');
        setReportId(null);
        setOfflineReportId(null);
        setHasUnsavedData(false);
        setSyncStatus('idle');
        setLastSyncTime(null);
        setForceUpdate(prev => prev + 1);
        showToast('Datos corruptos limpiados. Puede iniciar un nuevo recorrido.', 'info');
    };

    if (!user || loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
            }}>
                <div style={{
                    background: 'white',
                    padding: '20px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                }}>
                    Cargando datos del usuario...
                </div>
            </div>
        );
    }

    const canFinishRoute = () => {
        // Requiere conexión a internet — no se puede finalizar offline bajo ninguna circunstancia
        if (!isOnline) return false;

        // Bloquear si hay un punto abierto sin cerrar
        const hasPendingPoints = currentPoint !== null ||
            reportData.unrealizablePoints.some(p => !p.submitted && !p.offline);

        // Bloquear si hay segmentos guardados localmente que aún no llegaron al servidor
        const hasOfflineSegments =
            (reportData.maintenancePoints || []).filter(p => !p.submitted).length > 0 ||
            (reportData.unrealizablePoints || []).filter(p => !p.submitted).length > 0;

        return !hasPendingPoints && !hasOfflineSegments;
    };

    const hasAnyPendingPoint = () => {
        return currentPoint !== null || reportData.unrealizablePoints.some(p => !p.submitted && !p.offline);
    };

    const getPendingCount = () => {
        const pendingSegments = reportData.maintenancePoints.filter(p => !p.submitted).length;
        const pendingUnrealizables = reportData.unrealizablePoints.filter(p => !p.submitted).length;
        const currentPending = currentPoint ? 1 : 0;
        const offlineRoute = offlineReportId ? 1 : 0;
        return pendingSegments + pendingUnrealizables + currentPending + offlineRoute;
    };

    const getDisplayReportId = () => {
        return reportId || offlineReportId || 'N/A';
    };

    const getSyncStatusText = () => {
        switch (syncStatus) {
            case 'syncing': return '🔄 Sincronizando...';
            case 'success': return `✅ Sincronizado ${lastSyncTime ? lastSyncTime.toLocaleTimeString() : ''}`;
            case 'error': return '❌ Error de sincronización';
            default: return '⏳ Esperando sincronización';
        }
    };

    return (
        <div className="technician-page">
            <header className="page-header">
                <div className="header-content">
                    <div className="welcome-section">
                        <h1>Bienvenido, {user.name}</h1>
                        <p>Región: {user.region}</p>
                        <p>Distrito: {user.district}</p>
                        <p>versión: 1.5.1 (PROD)</p>
                    </div>
                    <div className="header-actions">
                        {/* Indicador de conexión */}
                        <div className="connection-status" style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '8px 12px',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            backgroundColor: isOnline ? '#d4edda' : '#f8d7da',
                            color: isOnline ? '#155724' : '#721c24',
                            border: `1px solid ${isOnline ? '#c3e6cb' : '#f5c6cb'}`,
                            marginRight: '10px'
                        }}>
                            {isOnline ? (
                                <>🌐 En línea</>
                            ) : (
                                <>📴 Offline - {getPendingCount()} puntos pendientes</>
                            )}
                        </div>

                        {/* Estado de sincronización */}
                        {(offlineReportId || reportData.offline) && (
                            <div className="sync-status" style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px 12px',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                backgroundColor:
                                    syncStatus === 'syncing' ? '#fff3cd' :
                                        syncStatus === 'success' ? '#d4edda' :
                                            syncStatus === 'error' ? '#f8d7da' : '#e2e3e5',
                                color:
                                    syncStatus === 'syncing' ? '#856404' :
                                        syncStatus === 'success' ? '#155724' :
                                            syncStatus === 'error' ? '#721c24' : '#383d41',
                                border: `1px solid ${syncStatus === 'syncing' ? '#ffeaa7' :
                                    syncStatus === 'success' ? '#c3e6cb' :
                                        syncStatus === 'error' ? '#f5c6cb' : '#d6d8db'
                                    }`,
                                marginRight: '10px'
                            }}>
                                {getSyncStatusText()}
                            </div>
                        )}

                        {/* Botón de sincronización manual */}
                        {formState === 'active' && (
                            <button
                                className="btn btn-sync"
                                onClick={syncPendingPoints}
                                disabled={!isOnline || getPendingCount() === 0 || syncStatus === 'syncing' || isLoading('syncPending')}
                                style={{
                                    padding: '8px 12px',
                                    fontSize: '14px',
                                    marginRight: '10px',
                                    backgroundColor: isOnline && getPendingCount() > 0 && syncStatus !== 'syncing' && !isLoading('syncPending') ? '#007bff' : '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isOnline && getPendingCount() > 0 && syncStatus !== 'syncing' && !isLoading('syncPending') ? 'pointer' : 'not-allowed',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '6px',
                                    minHeight: '36px'
                                }}
                            >
                                {isLoading('syncPending') ? (
                                    <LoadingSpinner size="small" text="Sincronizando..." />
                                ) : syncStatus === 'syncing' ? (
                                    '🔄 Sincronizando...'
                                ) : (
                                    '🔄 Sincronizar'
                                )}
                            </button>
                        )}

                        {user.role === 'admin' && (
                            <button className="btn btn-secondary" onClick={handleAdminPanel}>
                                Panel Admin
                            </button>
                        )}
                        {formState !== 'lunch' && (
                            <button className="btn btn-danger" onClick={handleLogout}>
                                Salir
                            </button>
                        )}
                    </div>
                </div>
            </header>

            <main className="main-content">
                {formState === 'initial' && (
                    <div className="form-section">
                        <div className="section-header">
                            <div className="icon-large">📍</div>
                            <h1>Iniciar Recorrido de Mantenimiento</h1>
                            <h2>⚠️ NO OLVIDES FINALIZAR TU RECORRIDO AL FINALIZAR TU JORNADA LABORAL ⚠️</h2>
                            {!isOnline && (
                                <div style={{
                                    backgroundColor: '#fff3cd',
                                    color: '#856404',
                                    padding: '12px',
                                    borderRadius: '6px',
                                    border: '1px solid #ffeaa7',
                                    marginTop: '10px'
                                }}>
                                    ⚠️ Sin conexión a internet. El recorrido se guardará localmente y se sincronizará cuando recupere la conexión.
                                </div>
                            )}
                        </div>
                        <div className="start-section">
                            <button
                                className="btn btn-start"
                                onClick={startRoute}
                                disabled={isLoading('startRoute')}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    minHeight: '50px'
                                }}
                            >
                                {isLoading('startRoute') ? (
                                    <LoadingSpinner size="medium" text="Iniciando..." />
                                ) : hasActiveRouteFromServer ? (
                                    '▶️ Reanuda tu recorrido'
                                ) : (
                                    '🚀 Iniciar Recorrido'
                                )}
                            </button>
                        </div>
                    </div>
                )}

                {formState === 'active' && (
                    <div className="form-section">
                        {/* Carrusel de anuncios e instrucciones siempre visible */}
                        <InfoCarousel />

                        <div className="report-header">
                            <div className="status-indicator active">
                                <div className="pulse-dot"></div>
                                <span>Recorrido Activo</span>
                            </div>
                            <p>ID: {getDisplayReportId()} {offlineReportId && '(Offline)'}</p>
                            <p>Iniciado: {new Date(reportData.startTime).toLocaleString()}</p>

                            {/* 🆕 BANNER ROJO: Alerta de recorrido de otro día */}
                            {reportData.startTime && (() => {
                                const reportDate = new Date(reportData.startTime).toDateString();
                                const today = new Date().toDateString();
                                if (reportDate !== today) {
                                    const reportStartDate = new Date(reportData.startTime);
                                    const diffTime = new Date().getTime() - reportStartDate.getTime();
                                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                    return (
                                        <div style={{
                                            backgroundColor: '#dc3545',
                                            color: 'white',
                                            padding: '15px 20px',
                                            borderRadius: '10px',
                                            marginTop: '15px',
                                            border: '4px solid #a71d2a',
                                            fontWeight: 'bold',
                                            animation: 'pulse-warning 2s infinite',
                                            boxShadow: '0 4px 15px rgba(220, 53, 69, 0.4)'
                                        }}>
                                            <div style={{
                                                fontSize: '1.3em',
                                                marginBottom: '12px',
                                                textAlign: 'center',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1px'
                                            }}>
                                                ⚠️ ESTE RECORRIDO ES DE OTRO DÍA ⚠️
                                            </div>

                                            <div style={{
                                                fontSize: '1em',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '10px'
                                            }}>
                                                <span>📅</span>
                                                <div>
                                                    <strong>Fecha del recorrido:</strong><br />
                                                    {reportStartDate.toLocaleDateString('es-MX', {
                                                        weekday: 'long',
                                                        day: 'numeric',
                                                        month: 'long',
                                                        year: 'numeric'
                                                    })}
                                                </div>
                                            </div>

                                            <div style={{
                                                fontSize: '1em',
                                                marginBottom: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '10px'
                                            }}>
                                                <span>📅</span>
                                                <div>
                                                    <strong>Fecha actual:</strong><br />
                                                    {new Date().toLocaleDateString('es-MX', {
                                                        weekday: 'long',
                                                        day: 'numeric',
                                                        month: 'long',
                                                        year: 'numeric'
                                                    })}
                                                </div>
                                            </div>

                                            <div style={{
                                                fontSize: '1em',
                                                marginBottom: '15px',
                                                textAlign: 'center',
                                                padding: '8px',
                                                backgroundColor: 'rgba(255,255,255,0.15)',
                                                borderRadius: '6px'
                                            }}>
                                                ⏰ <strong>Han pasado {diffDays} día(s)</strong>
                                            </div>

                                            <div style={{
                                                marginTop: '15px',
                                                padding: '12px',
                                                backgroundColor: 'rgba(255,255,255,0.25)',
                                                borderRadius: '8px',
                                                fontSize: '0.95em',
                                                lineHeight: '1.6',
                                                border: '2px solid rgba(255,255,255,0.3)'
                                            }}>
                                                <div style={{ marginBottom: '8px', fontSize: '1.1em' }}>
                                                    🔴 <strong>PROBLEMA:</strong>
                                                </div>
                                                Todos los segmentos que envíes se están guardando
                                                en el recorrido del día incorrecto.
                                                <div style={{ marginTop: '12px', fontSize: '1.1em' }}>
                                                    ✅ <strong>SOLUCIÓN:</strong>
                                                </div>
                                                Debes FINALIZAR este recorrido AHORA y después
                                                iniciar uno nuevo para el día de hoy.
                                            </div>
                                        </div>
                                    );
                                }
                                return null;
                            })()}

                            {!isOnline && (
                                <div style={{
                                    backgroundColor: '#fff3cd',
                                    color: '#856404',
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    marginTop: '8px'
                                }}>
                                    📴 Modo offline - Los datos se sincronizarán automáticamente
                                </div>
                            )}
                        </div>

                        <div className="action-buttons">
                            <button
                                className={`btn btn-primary btn-large ${hasAnyPendingPoint() ? 'btn-disabled' : ''}`}
                                onClick={addSegmentReport}
                                disabled={hasAnyPendingPoint()}
                            >
                                📊 Reporte de Segmento
                            </button>
                            <button
                                className={`btn btn-warning btn-large ${hasAnyPendingPoint() ? 'btn-disabled' : ''}`}
                                onClick={addUnrealizablePoint}
                                disabled={hasAnyPendingPoint()}
                            >
                                ⚠️ Punto No Realizable
                            </button>
                            <button
                                className="btn btn-lunch"
                                onClick={goToLunch}
                                disabled={isLoading('goToLunch')}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    minHeight: '40px'
                                }}
                            >
                                {isLoading('goToLunch') ? (
                                    <LoadingSpinner size="small" text="Pausando..." />
                                ) : (
                                    '🍽️ Ir a Comer'
                                )}
                            </button>
                        </div>

                        {hasAnyPendingPoint() && (
                            <div className="warning-message">
                                ⚠️ Envía o cierra el punto antes de seleccionar otro
                            </div>
                        )}

                        {currentPoint && (
                            <div className="current-point">
                                <div className="point-header">
                                    <h3>📊 Nuevo Reporte de Segmento</h3>
                                    <div className="location-info">
                                        📍 {currentPoint.location.latitude.toFixed(6)}, {currentPoint.location.longitude.toFixed(6)}
                                    </div>
                                </div>

                                <div className="photo-section-visual">
                                    <h3>🔧 En caso de realizar mantenimiento, tomar foto 📸 antes y después 📸</h3>

                                    <div className="photos-grid-dual">
                                        {['segment1', 'segment2'].map((type, index) => (
                                            <div key={type} className="photo-upload-visual">
                                                {currentPoint.photos[type] ? (
                                                    <div className="photo-upload-label photo-uploaded-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '15px', border: '1px solid #28a745', borderRadius: '12px' }}>
                                                        <div style={{ width: '80px', height: '80px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #28a745', background: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <ImageThumbnail file={currentPoint.photos[type]} />
                                                        </div>
                                                        <span style={{ fontSize: '0.95rem', margin: '4px 0 0 0', color: '#28a745', fontWeight: 'bold' }}>✓ Foto {index + 1} Cargada</span>
                                                        <small style={{ fontSize: '0.75rem', maxWidth: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{currentPoint.photos[type].name}</small>
                                                        <button
                                                            className="btn btn-sm btn-link"
                                                            style={{ color: '#dc3545', textDecoration: 'none', fontSize: '12px', marginTop: '5px', padding: '0' }}
                                                            onClick={() => {
                                                                setCurrentPoint(prev => ({
                                                                    ...prev,
                                                                    photos: { ...prev.photos, [type]: null }
                                                                }));
                                                                setForceUpdate(prev => prev + 1);
                                                            }}
                                                        >
                                                            Eliminar y cambiar
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="file-placeholder-options" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '15px', padding: '15px', border: '2px dashed #ccc', borderRadius: '12px', background: '#fcfcfc', minHeight: '130px' }}>
                                                        <span style={{ fontWeight: '500', fontSize: '14px', color: '#555' }}>Foto {index + 1} del Segmento</span>
                                                        <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                                            <label style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '10px 5px', background: '#eef3fc', border: '1px solid #c7d9f7', borderRadius: '8px', cursor: 'pointer', textAlign: 'center' }}>
                                                                <span style={{ fontSize: '20px' }}>📷</span>
                                                                <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#2b579a' }}>Cámara</span>
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    capture="environment"
                                                                    onChange={(e) => {
                                                                        if (e.target.files && e.target.files[0]) {
                                                                            updatePhotoInCurrentPoint(type, e.target.files[0], true);
                                                                        }
                                                                    }}
                                                                    style={{ display: 'none' }}
                                                                />
                                                            </label>
                                                            <label style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '10px 5px', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', textAlign: 'center' }}>
                                                                <span style={{ fontSize: '20px' }}>🖼️</span>
                                                                <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#666' }}>Galería</span>
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(e) => {
                                                                        if (e.target.files && e.target.files[0]) {
                                                                            updatePhotoInCurrentPoint(type, e.target.files[0], false);
                                                                        }
                                                                    }}
                                                                    style={{ display: 'none' }}
                                                                />
                                                            </label>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {user?.tipo_planta === 'PE' ? (
                                    <div className="activities-section" style={{ padding: '15px', background: '#fcfcfc', border: '1px solid #eee', borderRadius: '12px', marginTop: '15px', marginBottom: '15px' }}>
                                        <h3 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                                            📋 Hallazgos de Planta Externa:
                                        </h3>

                                        {/* Buscador */}
                                        <div style={{ marginBottom: '15px', position: 'relative' }}>
                                            <input
                                                type="text"
                                                placeholder="🔍 Buscar hallazgo o actividad..."
                                                value={peSearchTerm}
                                                onChange={(e) => {
                                                    const term = e.target.value;
                                                    setPeSearchTerm(term);

                                                    // Si está buscando, auto-expandir las secciones que tienen coincidencias
                                                    if (term.trim() !== '') {
                                                        const termUpper = term.toUpperCase();
                                                        const nextExpanded = {};
                                                        Object.keys(PE_FINDINGS_CATALOG).forEach(category => {
                                                            const hasMatch = PE_FINDINGS_CATALOG[category].some(f =>
                                                                f.label.toUpperCase().includes(termUpper)
                                                            );
                                                            if (hasMatch) {
                                                                nextExpanded[category] = true;
                                                            }
                                                        });
                                                        setPeExpandedSections(nextExpanded);
                                                    }
                                                }}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px 12px',
                                                    fontSize: '0.95rem',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '8px',
                                                    outline: 'none',
                                                    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                                                    transition: 'border-color 0.2s'
                                                }}
                                            />
                                        </div>

                                        {/* Acordeones por Categoría */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {Object.keys(PE_FINDINGS_CATALOG).map(category => {
                                                const findings = PE_FINDINGS_CATALOG[category];
                                                const termUpper = peSearchTerm.trim().toUpperCase();

                                                // Filtrar hallazgos de esta categoría
                                                const filteredFindings = termUpper === ''
                                                    ? findings
                                                    : findings.filter(f => f.label.toUpperCase().includes(termUpper));

                                                if (filteredFindings.length === 0) return null;

                                                const isExpanded = !!peExpandedSections[category];

                                                // Contar cuántos de esta categoría están seleccionados
                                                const selectedInCategory = currentPoint.activities?.filter(act =>
                                                    findings.some(f => f.label === act)
                                                ) || [];

                                                return (
                                                    <div key={category} style={{ border: '1px solid #eee', borderRadius: '8px', overflow: 'hidden' }}>
                                                        {/* Botón Cabecera del Acordeón */}
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setPeExpandedSections(prev => ({
                                                                    ...prev,
                                                                    [category]: !prev[category]
                                                                }));
                                                            }}
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 12px',
                                                                background: isExpanded ? '#f0f4f8' : '#f9f9f9',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                textAlign: 'left',
                                                                fontWeight: '600',
                                                                fontSize: '0.95rem',
                                                                color: '#333',
                                                                transition: 'background 0.2s'
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <span>{isExpanded ? '📂' : '📁'}</span>
                                                                <span>{category}</span>
                                                                {selectedInCategory.length > 0 && (
                                                                    <span style={{
                                                                        background: '#0056b3',
                                                                        color: 'white',
                                                                        fontSize: '0.75rem',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '10px',
                                                                        fontWeight: 'bold'
                                                                    }}>
                                                                        {selectedInCategory.length}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <span style={{ fontSize: '0.8rem', color: '#666' }}>
                                                                {isExpanded ? '▲' : '▼'}
                                                            </span>
                                                        </button>

                                                        {/* Contenido del Acordeón */}
                                                        {isExpanded && (
                                                            <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '8px', background: 'white' }}>
                                                                {filteredFindings.map(finding => {
                                                                    const isChecked = currentPoint.activities?.includes(finding.label) || false;

                                                                    // Color de la insignia de riesgo
                                                                    let badgeColor = '#6c757d'; // Bajo/Sin Riesgo
                                                                    let badgeBg = '#f8f9fa';
                                                                    if (finding.risk === 'ALTO' && finding.hasRisk) {
                                                                        badgeColor = '#dc3545';
                                                                        badgeBg = '#fde8eb';
                                                                    } else if (finding.risk === 'MEDIO') {
                                                                        badgeColor = '#fd7e14';
                                                                        badgeBg = '#fff3cd';
                                                                    } else if (finding.risk === 'BAJO' && finding.hasRisk) {
                                                                        badgeColor = '#17a2b8';
                                                                        badgeBg = '#dcf2f7';
                                                                    }

                                                                    return (
                                                                        <label
                                                                            key={finding.label}
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'space-between',
                                                                                gap: '10px',
                                                                                fontSize: '0.9rem',
                                                                                color: '#444',
                                                                                cursor: 'pointer',
                                                                                padding: '8px 10px',
                                                                                background: isChecked ? '#eaf2f8' : '#fcfcfc',
                                                                                border: isChecked ? '1px solid #b3d7ff' : '1px solid #f0f0f0',
                                                                                borderRadius: '6px',
                                                                                transition: 'all 0.15s ease'
                                                                            }}
                                                                        >
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isChecked}
                                                                                    onChange={(e) => {
                                                                                        const checked = e.target.checked;
                                                                                        setCurrentPoint(prev => {
                                                                                            const currentAct = prev.activities || [];
                                                                                            const newAct = checked
                                                                                                ? [...currentAct, finding.label]
                                                                                                : currentAct.filter(a => a !== finding.label);
                                                                                            return { ...prev, activities: newAct };
                                                                                        });
                                                                                    }}
                                                                                    style={{ width: '16px', height: '16px', accentColor: '#0056b3' }}
                                                                                />
                                                                                <span style={{ fontWeight: isChecked ? '500' : 'normal' }}>{finding.label}</span>
                                                                            </div>
                                                                            <span style={{
                                                                                fontSize: '0.7rem',
                                                                                fontWeight: 'bold',
                                                                                padding: '2px 6px',
                                                                                borderRadius: '4px',
                                                                                color: badgeColor,
                                                                                background: badgeBg,
                                                                                border: `1px solid ${badgeColor}40`,
                                                                                whiteSpace: 'nowrap'
                                                                            }}>
                                                                                {finding.hasRisk ? `CON RIESGO - ${finding.risk}` : `SIN RIESGO - ${finding.risk}`}
                                                                            </span>
                                                                        </label>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="activities-section" style={{ padding: '15px', background: '#fcfcfc', border: '1px solid #eee', borderRadius: '12px', marginTop: '15px', marginBottom: '15px' }}>
                                        <h3 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                                            📋 Actividades de mantenimiento realizadas:
                                        </h3>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {[
                                                'Acomodo y tensado en altura',
                                                'Organización de acometidas',
                                                'Cerrado de caja de 2N',
                                                'Retiro de acometida',
                                                'Poda de árboles',
                                                'Sin incidencias por levantar',
                                            ].map(activity => {
                                                const isChecked = currentPoint.activities?.includes(activity) || false;
                                                return (
                                                    <label
                                                        key={activity}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '10px',
                                                            fontSize: '0.95rem',
                                                            color: '#444',
                                                            cursor: 'pointer',
                                                            padding: '8px 10px',
                                                            background: isChecked ? '#eaf2f8' : '#f9f9f9',
                                                            border: isChecked ? '1px solid #b3d7ff' : '1px solid #eee',
                                                            borderRadius: '8px',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isChecked}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                setCurrentPoint(prev => {
                                                                    const currentAct = prev.activities || [];
                                                                    const newAct = checked
                                                                        ? [...currentAct, activity]
                                                                        : currentAct.filter(a => a !== activity);
                                                                    return { ...prev, activities: newAct };
                                                                });
                                                            }}
                                                            style={{ width: '18px', height: '18px', accentColor: '#0056b3' }}
                                                        />
                                                        {activity}
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                <div className="point-actions">
                                    <button
                                        className="btn btn-success btn-submit"
                                        onClick={submitSegmentReport}
                                        disabled={isLoading('submitSegment')}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            minHeight: '40px'
                                        }}
                                    >
                                        {isLoading('submitSegment') ? (
                                            <LoadingSpinner size="small" text="Enviando..." />
                                        ) : isOnline ? '📤 Enviar Reporte' : '💾 Guardar Offline'}
                                    </button>
                                    <button className="btn btn-secondary" onClick={() => setCurrentPoint(null)}>
                                        ❌ Cancelar
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="completed-points">
                            <h3>📋 Puntos Registrados ({reportData.maintenancePoints.length + reportData.unrealizablePoints.filter(p => p.submitted || p.offline).length})</h3>

                            {reportData.maintenancePoints.map(point => (
                                <div key={point.id} className="point-summary maintenance">
                                    <div className="point-icon">📊</div>
                                    <div className="point-info">
                                        <h4>Reporte de Segmento</h4>
                                        <p>{point.submitted ? `Enviado: ${new Date(point.sentAt || point.submittedAt).toLocaleString()}` : 'Guardado offline'}</p>
                                        {!point.submitted && (
                                            <button
                                                className="btn btn-primary btn-small"
                                                style={{ marginTop: '10px' }}
                                                onClick={() => syncSingleSegment(point)}
                                                disabled={isLoading(`sync-${point.id}`)}
                                            >
                                                {isLoading(`sync-${point.id}`) ? 'Enviando...' : '⬆️ Reintentar Envío'}
                                            </button>
                                        )}
                                    </div>
                                    <div className={`status-badge ${point.submitted ? 'success' : 'offline'}`}>
                                        {point.submitted ? '✓ Enviado' : '📱 Offline'}
                                    </div>
                                </div>
                            ))}

                            {reportData.unrealizablePoints.map(point => (
                                <div key={point.id} className={`point-summary unrealizable ${!point.submitted && !point.offline ? 'pending' : ''}`}>
                                    <div className="point-icon">⚠️</div>
                                    <div className="point-info">
                                        <h4>Punto No Realizable</h4>
                                        {point.submitted || point.offline ? (
                                            <div>
                                                <p>Motivo: {point.reason}</p>
                                                <p>{point.submitted ? `Enviado: ${new Date(point.sentAt || point.submittedAt).toLocaleString()}` : 'Guardado offline'}</p>
                                                {!point.submitted && point.offline && (
                                                    <button
                                                        className="btn btn-primary btn-small"
                                                        style={{ marginTop: '10px' }}
                                                        onClick={() => syncSingleUnrealizable(point)}
                                                        disabled={isLoading(`unrealizable-${point.id}`)}
                                                    >
                                                        {isLoading(`unrealizable-${point.id}`) ? 'Enviando...' : '⬆️ Reintentar Envío'}
                                                    </button>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="unrealizable-form">
                                                <div className="form-group-visual">
                                                    <label>🚫 Motivo</label>
                                                    <select
                                                        value={point.reason}
                                                        onChange={(e) => updateUnrealizablePoint(point.id, 'reason', e.target.value)}
                                                        className="select-visual"
                                                    >
                                                        <option value="">Selecciona un motivo</option>
                                                        <option value="falta_permisos">Falta de permisos</option>
                                                        <option value="mal_clima">Mal clima</option>
                                                        <option value="problemas_acceso">Problemas de acceso</option>
                                                        <option value="zona_roja">Zona roja/peligrosa</option>
                                                        <option value="sin_material">Sin material necesario</option>
                                                        <option value="zona_complicada" disabled={reportData.unrealizablePoints.filter(p => p.reason === 'zona_complicada' && p.id !== point.id).length >= 4}>
                                                            Zona complicada {reportData.unrealizablePoints.filter(p => p.reason === 'zona_complicada' && p.id !== point.id).length >= 4 ? '(Máx 4)' : ''}
                                                        </option>
                                                        <option value="sin_ot">Sin carga de trabajo por distrito (SIN OT)</option>
                                                        <option value="abasto_material">Abasto de material</option>
                                                    </select>
                                                </div>

                                                <div className="form-group-visual">
                                                    <label>💬 Comentarios</label>
                                                    <textarea
                                                        value={point.comments}
                                                        onChange={(e) => updateUnrealizablePoint(point.id, 'comments', e.target.value)}
                                                        placeholder="Describe la situación..."
                                                        rows="2"
                                                        className="textarea-visual"
                                                    />
                                                </div>

                                                <div className="form-group-visual">
                                                    <label>📷 Evidencia</label>
                                                    <div className="file-upload-visual">
                                                        {point.evidencePhoto ? (
                                                            <div className="file-upload-label file-uploaded-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '15px', border: '1px solid #ffc107', borderRadius: '8px', background: '#fff' }}>
                                                                <div style={{ width: '80px', height: '80px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ffc107', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <ImageThumbnail file={point.evidencePhoto} />
                                                                </div>
                                                                <span style={{ color: '#ff9500', fontWeight: 'bold', fontSize: '13px' }}>✓ {point.evidencePhoto.name}</span>
                                                                <button
                                                                    className="btn btn-sm btn-link"
                                                                    style={{ color: '#dc3545', textDecoration: 'none', fontSize: '12px', marginTop: '5px', padding: '0' }}
                                                                    onClick={() => {
                                                                        updateUnrealizablePoint(point.id, 'evidencePhoto', null);
                                                                    }}
                                                                >
                                                                    Eliminar y cambiar
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="file-placeholder-options" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '15px', padding: '15px', border: '2px dashed #ccc', borderRadius: '12px', background: '#fcfcfc', minHeight: '130px', width: '100%' }}>
                                                                <span style={{ fontWeight: '500', fontSize: '14px', color: '#555' }}>Evidencia Fotográfica</span>
                                                                <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                                                    <label style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '10px 5px', background: '#fff9e6', border: '1px solid #ffe8a3', borderRadius: '8px', cursor: 'pointer', textAlign: 'center' }}>
                                                                        <span style={{ fontSize: '20px' }}>📷</span>
                                                                        <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#b27a00' }}>Cámara</span>
                                                                        <input
                                                                            type="file"
                                                                            accept="image/*"
                                                                            capture="environment"
                                                                            onChange={(e) => {
                                                                                if (e.target.files && e.target.files[0]) {
                                                                                    updateUnrealizablePoint(point.id, 'evidencePhoto', e.target.files[0], true);
                                                                                }
                                                                            }}
                                                                            style={{ display: 'none' }}
                                                                        />
                                                                    </label>
                                                                    <label style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '10px 5px', background: '#f5f5f5', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', textAlign: 'center' }}>
                                                                        <span style={{ fontSize: '20px' }}>🖼️</span>
                                                                        <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#666' }}>Galería</span>
                                                                        <input
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={(e) => {
                                                                                if (e.target.files && e.target.files[0]) {
                                                                                    updateUnrealizablePoint(point.id, 'evidencePhoto', e.target.files[0], false);
                                                                                }
                                                                            }}
                                                                            style={{ display: 'none' }}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="point-actions">
                                                    <button
                                                        className="btn btn-warning"
                                                        onClick={() => submitUnrealizablePoint(point.id)}
                                                        disabled={isLoading(`unrealizable-${point.id}`)}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '8px',
                                                            minHeight: '36px'
                                                        }}
                                                    >
                                                        {isLoading(`unrealizable-${point.id}`) ? (
                                                            <LoadingSpinner size="small" text="Enviando..." />
                                                        ) : isOnline ? '📤 Enviar Justificación' : '💾 Guardar Offline'}
                                                    </button>
                                                    <button className="btn btn-danger btn-small" onClick={() => deleteUnrealizablePoint(point.id)}>
                                                        🗑️
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className={`status-badge ${point.submitted ? 'success' : point.offline ? 'offline' : 'pending'}`}>
                                        {point.submitted ? '✓ Enviado' : point.offline ? '📱 Offline' : '⏳ Pendiente'}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="finish-section">
                            <button
                                className="btn btn-finish"
                                onClick={finishRoute}
                                disabled={!canFinishRoute()}
                            >
                                {canFinishRoute() ?
                                    '🏁 Finalizar Recorrido' :
                                    (() => {
                                        if (!isOnline) return '📵 Sin internet — conectate para finalizar';
                                        const offlineCount =
                                            (reportData.maintenancePoints || []).filter(p => !p.submitted).length +
                                            (reportData.unrealizablePoints || []).filter(p => !p.submitted).length;
                                        if (offlineCount > 0) return `🔄 Sincroniza ${offlineCount} segmento(s) offline antes de finalizar`;
                                        if (hasAnyPendingPoint()) return '⏳ Envía o cierra los puntos pendientes para finalizar';
                                        return '🏁 Finalizar Recorrido';
                                    })()
                                }
                            </button>
                        </div>
                    </div>
                )}

                {formState === 'lunch' && (
                    <div className="form-section lunch-mode">
                        <div className="lunch-header">
                            <div className="icon-large">🍽️</div>
                            <h2>Tiempo de Comida</h2>
                            <p>El tiempo está pausado</p>
                            <div className="pause-indicator">
                                <div className="pause-icon">⏸️</div>
                                <span>Recorrido en Pausa</span>
                            </div>
                        </div>

                        <div className="lunch-actions">
                            <button
                                className="btn btn-success btn-large"
                                onClick={resumeFromLunch}
                                disabled={isLoading('resumeFromLunch')}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    minHeight: '50px'
                                }}
                            >
                                {isLoading('resumeFromLunch') ? (
                                    <LoadingSpinner size="medium" text="Reanudando..." />
                                ) : (
                                    '▶️ Reanudar Recorrido'
                                )}
                            </button>

                            <div className="or-divider">
                                <span>O si no regresas</span>
                            </div>

                            <button
                                className="btn btn-finish"
                                onClick={finishRoute}
                                disabled={!canFinishRoute() || isLoading('finishRoute')}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    minHeight: '50px'
                                }}
                            >
                                {isLoading('finishRoute') ? (
                                    <LoadingSpinner size="medium" text="Finalizando..." />
                                ) : canFinishRoute() ? (
                                    '🏁 Finalizar Recorrido'
                                ) : (() => {
                                    if (!isOnline) return '📵 Sin internet — conectate para finalizar';
                                    const offlineCount =
                                        (reportData.maintenancePoints || []).filter(p => !p.submitted).length +
                                        (reportData.unrealizablePoints || []).filter(p => !p.submitted).length;
                                    if (offlineCount > 0) return `🔄 Sincroniza ${offlineCount} segmento(s) offline antes de finalizar`;
                                    if (hasAnyPendingPoint()) return '⏳ Envía o cierra los puntos pendientes para finalizar';
                                    return '🏁 Finalizar Recorrido';
                                })()}
                            </button>
                        </div>
                    </div>
                )}

                {formState === 'finished' && (
                    <div className="form-section finished">
                        <div className="success-header">
                            <div className="icon-large">🎉</div>
                            <h2>Recorrido Completado</h2>
                            {reportData.offline && (
                                <div style={{
                                    backgroundColor: '#fff3cd',
                                    color: '#856404',
                                    padding: '12px',
                                    borderRadius: '6px',
                                    border: '1px solid #ffeaa7',
                                    marginTop: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    <span>📴 Recorrido finalizado offline. Se enviará cuando recupere la conexión.</span>
                                    {isOnline && (
                                        <button
                                            onClick={syncPendingPoints}
                                            style={{
                                                padding: '6px 12px',
                                                backgroundColor: '#007bff',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontSize: '12px'
                                            }}
                                        >
                                            Enviar Ahora
                                        </button>
                                    )}
                                </div>
                            )}
                            {reportData.tiempoDesfasado && (
                                <div style={{
                                    backgroundColor: '#f8d7da',
                                    color: '#721c24',
                                    padding: '14px',
                                    borderRadius: '6px',
                                    border: '2px solid #f5c6cb',
                                    marginTop: '10px',
                                    fontWeight: 'bold'
                                }}>
                                    <div style={{ fontSize: '16px', marginBottom: '8px' }}>🚨 TIEMPO SOSPECHOSO</div>
                                    <div style={{ fontSize: '13px', lineHeight: '1.4' }}>
                                        {reportData.razonDesfase}<br />
                                        <span style={{ fontSize: '12px', opacity: 0.9 }}>
                                            Este reporte ha sido enviado a AUDITORÍA para revisión manual.
                                        </span>
                                    </div>
                                </div>
                            )}
                            {lastSyncTime && (
                                <div style={{
                                    backgroundColor: '#d4edda',
                                    color: '#155724',
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #c3e6cb',
                                    marginTop: '10px',
                                    fontSize: '14px'
                                }}>
                                    ✅ Última sincronización: {lastSyncTime.toLocaleString()}
                                </div>
                            )}
                        </div>

                        <div className="summary-stats">
                            <div className="stat-card primary">
                                <div className="stat-icon">📊</div>
                                <div className="stat-number">{reportData.maintenancePoints.length}</div>
                                <div className="stat-label">Reportes de Segmento</div>
                            </div>

                            <div className="stat-card warning">
                                <div className="stat-icon">⚠️</div>
                                <div className="stat-number">{reportData.unrealizablePoints.filter(p => p.submitted || p.offline).length}</div>
                                <div className="stat-label">Puntos No Realizables</div>
                            </div>

                            {/* 🆕 TIEMPO OPERATIVO EFECTIVO (REEMPLAZADO POR NUEVA SECCIÓN ABAJO PERO MANTENEMOS STAT SI ACASO) */}
                        </div>

                        {/* 🆕 MÉTRICAS DE ADHERENCIA (TIEMPOS) */}
                        {(() => {
                            const timeMetrics = calcularMetricasAdherencia(reportData);
                            return (
                                <div className="metrics-and-audit-section" style={{ marginBottom: '30px', borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: '20px' }}>
                                    <h3 style={{ textAlign: 'center', color: 'black', marginBottom: '15px', fontSize: '1.2rem' }}>🕒 Rendimiento de Adherencia</h3>
                                    <div className="summary-stats distance-section" style={{ marginTop: '0' }}>
                                        <div className="stat-card info">
                                            <div className="stat-icon">⏰</div>
                                            <div className="stat-number">{formatTiempoOperativo(timeMetrics.tiempoTrabajado)}</div>
                                            <div className="stat-label">Tiempo Trabajado (Bruto)</div>
                                            <div className="stat-sublabel">Total jornada (menos breaks)</div>
                                        </div>

                                        <div className={`stat-card ${timeMetrics.aplicaPenalizacion ? 'warning-border' : 'success-border'}`}>
                                            <div className="stat-icon">🏃</div>
                                            <div className="stat-number">
                                                {formatTiempoOperativo(timeMetrics.tiempoOperativoEfectivo)}
                                            </div>
                                            <div className="stat-label">Tiempo Operativo Efectivo</div>
                                            <div style={{ fontSize: '0.8rem', color: timeMetrics.aplicaPenalizacion ? '#856404' : '#28a745', fontWeight: 'bold', marginTop: '5px' }}>
                                                {timeMetrics.aplicaPenalizacion ? '⚠️ PENALIZACIÓN APLICADA' : '✅ ADHERENCIA CORRECTA'}
                                            </div>
                                        </div>
                                    </div>

                                    {timeMetrics.alertas && timeMetrics.alertas.length > 0 && (
                                        <div className="audit-alerts-container" style={{ borderColor: '#ffc107', background: '#fff9e6' }}>
                                            <div className="audit-alert-header" style={{ background: '#ffc107', color: '#856404' }}>
                                                <span className="audit-icon">⚠️</span>
                                                <h3>Descuento de Tiempo</h3>
                                            </div>
                                            <div className="audit-alert-content" style={{ padding: '12px' }}>
                                                {timeMetrics.alertas.map((alerta, idx) => (
                                                    <div key={idx} className="alert-item" style={{ background: '#fff3cd', borderLeft: '4px solid #ffc107', padding: '10px 12px', marginBottom: idx < timeMetrics.alertas.length - 1 ? '8px' : '0', borderRadius: '6px' }}>
                                                        <p style={{ color: '#856404', margin: 0, fontSize: '0.85rem' }}>
                                                            {alerta.tipo === 'inicio_lejos' && '📍 '}
                                                            {alerta.tipo === 'cierre_lejos' && '🏁 '}
                                                            {alerta.tipo === 'cierre_otro_dia' && '📅 '}
                                                            {alerta.tipo === 'sesion_desfasada' && '⏳ '}
                                                            {alerta.mensaje}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* ⏱️ ALERTA DE TIEMPOS SIN REGISTRO (CONSIGNA DE 2 HORAS) */}
                                    {reportData.inactividad && reportData.inactividad.tiene_inactividad && (
                                        <div className="audit-alerts-container" style={{ borderColor: '#fd7e14', background: '#fff9f2', marginTop: '15px' }}>
                                            <div className="audit-alert-header" style={{ background: '#fd7e14', color: '#ffffff' }}>
                                                <span className="audit-icon">⏱️</span>
                                                <h3>Aviso de Tiempos sin Registro</h3>
                                            </div>
                                            <div className="audit-alert-content" style={{ padding: '14px' }}>
                                                <p style={{ color: '#d9480f', fontWeight: 'bold', fontSize: '0.95rem', margin: '0 0 10px 0' }}>
                                                    ⚠️ {reportData.inactividad.mensaje_consigna || "Recuerda que debes mandar segmentos antes de las 2 horas."}
                                                </p>
                                                <div style={{ background: '#ffe8cc', padding: '10px 14px', borderRadius: '6px', marginBottom: '12px', borderLeft: '4px solid #fd7e14' }}>
                                                    <span style={{ fontSize: '0.95rem', color: '#d9480f' }}>
                                                        <strong>Tiempo sin registros:</strong> {reportData.inactividad.tiempo_formateado} ({reportData.inactividad.total_segundos} seg)
                                                    </span>
                                                </div>

                                                <div style={{ fontSize: '0.85rem', color: '#495057', marginBottom: '8px', fontWeight: 'bold' }}>
                                                    Detalle por tramos:
                                                </div>
                                                <div className="alert-list">
                                                    {reportData.inactividad.tramos && reportData.inactividad.tramos.map((tramo, idx) => (
                                                        <div key={idx} className="alert-item" style={{ background: '#ffffff', border: '1px solid #ffd8a8', borderLeft: '4px solid #fd7e14', padding: '8px 12px', marginBottom: '6px', borderRadius: '4px' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <span style={{ fontWeight: '500', color: '#212529', fontSize: '0.85rem' }}>
                                                                    Del <strong>{tramo.origen}</strong> al <strong>{tramo.destino}</strong>
                                                                </span>
                                                                <span style={{ color: '#d9480f', fontWeight: 'bold', fontSize: '0.9rem' }}>
                                                                    {tramo.tiempo_formateado}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })()}

                        {/* 🆕 MÉTRICAS DE DISTANCIA Y AUDITORÍA (SOLO SE MUESTRAN AL FINALIZAR) */}
                        {formState === 'finished' && (() => {
                            const metrics = calcularMetricasDistancia(reportData);
                            return (
                                <div className="metrics-and-audit-section" style={{ marginBottom: '30px' }}>
                                    <h3 style={{ textAlign: 'center', color: 'black', marginBottom: '15px', fontSize: '1.2rem' }}>📈 Rendimiento de Distancia</h3>
                                    <div className="summary-stats distance-section" style={{ marginTop: '0' }}>
                                        <div className="stat-card info">
                                            <div className="stat-icon">📏</div>
                                            <div className="stat-number">{metrics.total} m</div>
                                            <div className="stat-label">Distancia Total</div>
                                        </div>

                                        <div className={`stat-card ${metrics.alertas.length > 0 ? 'danger-border' : 'success-border'}`}>
                                            <div className="stat-icon">{metrics.alertas.length > 0 ? '🚫' : '✅'}</div>
                                            <div className="stat-number">{metrics.filtrada} m</div>
                                            <div className="stat-label">Distancia Operativa Efectiva</div>
                                            <div style={{ fontSize: '0.8rem', color: metrics.alertas.length > 0 ? '#dc3545' : '#28a745', fontWeight: 'bold', marginTop: '5px' }}>
                                                {metrics.alertas.length > 0 ? '⚠️ TRAMOS DESCONTADOS' : '✅ RECORRIDO ÓPTIMO'}
                                            </div>
                                            {metrics.alertas.length > 0 && (
                                                <div className="stat-sublabel" style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                                    Se descontaron {metrics.total - metrics.filtrada} m
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {metrics.descuentosDistancia && metrics.descuentosDistancia.length > 0 && (
                                        <div className="audit-alerts-container" style={{ borderColor: '#ffc107', background: '#fff9e6', marginTop: '15px', marginBottom: '15px' }}>
                                            <div className="audit-alert-header" style={{ background: '#ffc107', color: '#856404' }}>
                                                <span className="audit-icon">⚠️</span>
                                                <h3>Descuento de Distancia</h3>
                                            </div>
                                            <div className="audit-alert-content" style={{ padding: '12px' }}>
                                                {metrics.descuentosDistancia.map((alerta, idx) => (
                                                    <div key={idx} className="alert-item" style={{ background: '#fff3cd', borderLeft: '4px solid #ffc107', padding: '10px 12px', marginBottom: idx < metrics.descuentosDistancia.length - 1 ? '8px' : '0', borderRadius: '6px' }}>
                                                        <p style={{ color: '#856404', margin: 0, fontSize: '0.85rem' }}>
                                                            {alerta.tipo === 'inicio_lejos' && '📍 '}
                                                            {alerta.tipo === 'cierre_lejos' && '🏁 '}
                                                            {alerta.mensaje}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {metrics.alertas.length > 0 && (
                                        <div className="audit-alerts-container">
                                            <div className="audit-alert-header">
                                                <span className="audit-icon">🚨</span>
                                                <h3>Auditoría por Tiradas Largas</h3>
                                            </div>
                                            <div className="audit-alert-content">
                                                <p>Se identificaron {metrics.alertas.length} tramos que exceden el límite permitido (150m):</p>
                                                <div className="alert-list">
                                                    {metrics.alertas.map((alerta, idx) => (
                                                        <div key={idx} className="alert-item">
                                                            <div className="alert-item-info">
                                                                {alerta.esInicio || alerta.esCierre ? (
                                                                    <span className="alert-tag">{alerta.inicio} → {alerta.fin}</span>
                                                                ) : (
                                                                    <span className="alert-tag">Segmentos: #{alerta.dbId1 || '?'} → #{alerta.dbId2 || '?'}</span>
                                                                )}
                                                                <span className="alert-dist">{alerta.distancia} metros</span>
                                                            </div>
                                                            <p className="alert-message">⚠️ Distancia excede el límite permitido ({alerta.distancia}m). Este tramo se descuenta de la operativa efectiva.</p>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="audit-footer">
                                                    <p>Recuerda: El levantamiento debe ser cada 50-80 metros dependiendo de la zona.</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })()}


                        <button className="btn btn-primary btn-large" onClick={prepareNewRoute}>
                            🔄 Nuevo Recorrido
                        </button>
                    </div>
                )}

                {/* 🛠️ PANEL SIMULADOR DRAGGABLE (SOLO STAGING/DEV) */}
                {isSimulatorEnabled && formState !== 'finished' && (
                    <div
                        ref={simPanelRef}
                        style={{
                            position: 'fixed',
                            ...(simPanelPos.y !== null
                                ? { top: `${simPanelPos.y}px`, left: `${simPanelPos.x}px` }
                                : { bottom: '80px', left: `${simPanelPos.x}px` }
                            ),
                            width: 'min(340px, calc(100vw - 20px))',
                            background: 'rgba(0,0,0,0.9)',
                            color: 'white',
                            borderRadius: '12px',
                            zIndex: 2000,
                            border: '2px solid #ffc107',
                            boxShadow: '0 0 20px rgba(0,0,0,0.5)',
                            userSelect: 'none',
                            touchAction: 'none'
                        }}
                    >
                        {/* DRAG HANDLE */}
                        <div
                            onMouseDown={handleSimPanelDragStart}
                            onTouchStart={handleSimPanelDragStart}
                            style={{
                                padding: '8px 12px',
                                cursor: 'grab',
                                background: 'rgba(255,193,7,0.25)',
                                borderRadius: '10px 10px 0 0',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '1px solid rgba(255,255,255,0.15)'
                            }}
                        >
                            <span style={{ fontWeight: 'bold', fontSize: '0.85rem' }}>🛠️ SIMULADOR STAGING</span>
                            <span style={{ fontSize: '0.65rem', opacity: 0.7 }}>⠿ arrastra</span>
                        </div>

                        <div style={{ padding: '10px 12px' }}>
                            {/* ─── GPS SECTION ─── */}
                            <div style={{ marginBottom: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                    <span style={{ fontWeight: 'bold', fontSize: '0.8rem' }}>📍 GPS</span>
                                    <span style={{ fontSize: '0.65rem', opacity: 0.7 }}>
                                        {simulatedLocation ? `${simulatedLocation.latitude.toFixed(5)}, ${simulatedLocation.longitude.toFixed(5)}` : 'Cargando...'}
                                    </span>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '5px' }}>
                                    <button
                                        onClick={() => moveSimulatedLocation(60, 0)}
                                        style={{ padding: '6px', background: '#28a745', border: 'none', borderRadius: '5px', color: 'white', fontSize: '0.7rem' }}
                                    >
                                        🏃 +60m
                                    </button>
                                    <button
                                        onClick={() => moveSimulatedLocation(250, 0)}
                                        style={{ padding: '6px', background: '#dc3545', border: 'none', borderRadius: '5px', color: 'white', fontSize: '0.7rem' }}
                                    >
                                        🚗 +250m
                                    </button>
                                    <button
                                        onClick={() => setSimulatedLocation(null)}
                                        style={{ padding: '6px', background: '#6c757d', border: 'none', borderRadius: '5px', color: 'white', fontSize: '0.7rem' }}
                                    >
                                        🔄 Reset
                                    </button>
                                </div>
                            </div>

                            {/* ─── TIEMPO SECTION ─── */}
                            <div style={{ paddingTop: '8px', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                    <span style={{ fontWeight: 'bold', fontSize: '0.8rem' }}>⏱️ TIEMPO</span>
                                    <span style={{
                                        fontSize: '0.75rem',
                                        fontWeight: 'bold',
                                        color: simulatedTimeOffsetMinutes !== 0 ? '#ffc107' : '#8f8',
                                        background: simulatedTimeOffsetMinutes !== 0 ? 'rgba(255,193,7,0.2)' : 'rgba(0,255,0,0.1)',
                                        padding: '2px 8px',
                                        borderRadius: '10px'
                                    }}>
                                        {formatTimeOffset(simulatedTimeOffsetMinutes)}
                                    </span>
                                </div>
                                <div style={{ fontSize: '0.65rem', marginBottom: '6px', opacity: 0.7, textAlign: 'center' }}>
                                    Hora simulada: {getSimulatedDate().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })} — {getSimulatedDate().toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' })}
                                </div>

                                {/* Media hora buttons */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px', marginBottom: '5px' }}>
                                    <button
                                        onClick={() => setSimulatedTimeOffsetMinutes(prev => prev - 30)}
                                        style={{ padding: '6px', background: '#0d6efd', border: 'none', borderRadius: '5px', color: 'white', fontSize: '0.72rem', fontWeight: 'bold' }}
                                    >
                                        ◀ -30 min
                                    </button>
                                    <button
                                        onClick={() => setSimulatedTimeOffsetMinutes(prev => prev + 30)}
                                        style={{ padding: '6px', background: '#0d6efd', border: 'none', borderRadius: '5px', color: 'white', fontSize: '0.72rem', fontWeight: 'bold' }}
                                    >
                                        +30 min ▶
                                    </button>
                                </div>

                                {/* Day buttons */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px', marginBottom: '5px' }}>
                                    <button
                                        onClick={() => setSimulatedTimeOffsetMinutes(prev => prev - 1440)}
                                        style={{ padding: '5px', background: '#343a40', border: '1px solid #6c757d', borderRadius: '4px', color: 'white', fontSize: '0.7rem' }}
                                    >
                                        ⏪ -1 Día
                                    </button>
                                    <button
                                        onClick={() => setSimulatedTimeOffsetMinutes(prev => prev + 1440)}
                                        style={{ padding: '5px', background: '#343a40', border: '1px solid #6c757d', borderRadius: '4px', color: 'white', fontSize: '0.7rem' }}
                                    >
                                        +1 Día ⏩
                                    </button>
                                </div>

                                {/* Reset */}
                                <button
                                    onClick={() => setSimulatedTimeOffsetMinutes(0)}
                                    disabled={simulatedTimeOffsetMinutes === 0}
                                    style={{
                                        width: '100%',
                                        padding: '5px',
                                        background: simulatedTimeOffsetMinutes !== 0 ? '#dc3545' : '#6c757d',
                                        border: 'none',
                                        borderRadius: '4px',
                                        color: simulatedTimeOffsetMinutes !== 0 ? 'white' : '#aaa',
                                        fontSize: '0.7rem'
                                    }}
                                >
                                    🔄 Reset Tiempo (Ahora)
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </main>

            <Toast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ show: false, message: '', type: '' })}
            />

            <style jsx>{`
                .technician-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.page-header {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    color: white;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.header-content {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.welcome-section h1 {
    margin: 0 0 5px 0;
    font-size: 1.5rem;
}

.welcome-section p {
    margin: 2px 0;
    opacity: 0.9;
}

.header-actions {
    display: flex;
    gap: 10px;
}

.main-content {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}

.form-section {
    background: white;
    border-radius: 20px;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.section-header, .report-header {
    text-align: center;
    margin-bottom: 30px;
}

.icon-large {
    font-size: 4rem;
    margin-bottom: 10px;
}

.status-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
}

.status-indicator.active {
    color: #28a745;
    font-weight: 600;
}

.pulse-dot {
    width: 12px;
    height: 12px;
    background: #28a745;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7); }
    70% { box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
    100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
}

.action-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin: 30px 0;
}

.btn-large {
    padding: 20px;
    font-size: 1.1rem;
    border-radius: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 80px;
    text-align: center;
}

.btn-lunch {
    grid-column: 1 / -1;
    background: #ff9500;
    color: white;
    border: none;
    padding: 15px;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-lunch:hover {
    background: #e6850e;
    transform: translateY(-2px);
}

.warning-message {
    background: #fff3cd;
    color: #856404;
    padding: 15px;
    border-radius: 10px;
    text-align: center;
    margin: 20px 0;
    border-left: 4px solid #ffc107;
}

.current-point {
    background: linear-gradient(135deg, #f8f9ff 0%, #e6f2ff 100%);
    border: 2px solid #4facfe;
    border-radius: 15px;
    padding: 25px;
    margin: 25px 0;
}

.point-header {
    text-align: center;
    margin-bottom: 20px;
}

.point-header h3 {
    color: #2c5aa0;
    margin-bottom: 5px;
}

.location-info {
    color: #666;
    font-size: 0.9rem;
    background: rgba(255,255,255,0.7);
    padding: 8px 15px;
    border-radius: 20px;
    display: inline-block;
}

.photo-section-visual {
    margin: 25px 0;
        
}
.photo-section-visual h3 {
  color: #f16c6c;
  text-align: center;
  margin-bottom: 20px;
}

.photo-section-visual h4 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
}

.photo-upload-visual {
    display: flex;
    justify-content: center;
}

.photos-grid-dual {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    max-width: 600px;
    margin: 0 auto;
}

.photo-upload-label {
    display: block;
    width: 100%;
    max-width: 280px;
    min-height: 140px;
    padding: 20px 15px;
    border: 3px dashed #4facfe;
    border-radius: 15px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: white;
    box-sizing: border-box;
    overflow: hidden;
}

.photo-upload-label:hover {
    border-color: #2196f3;
    background: #f0f8ff;
    transform: translateY(-2px);
}

.photo-placeholder .camera-icon {
    font-size: 3rem;
    margin-bottom: 10px;
}

.photo-placeholder span {
    display: block;
    font-size: 1.1rem;
    font-weight: 600;
    color: #4facfe;
    margin-bottom: 5px;
}

.photo-placeholder small {
    color: #666;
    font-size: 0.9rem;
}

.photo-uploaded {
    color: #28a745;
}

.photo-uploaded .check-icon {
    font-size: 3rem;
    margin-bottom: 10px;
}

.photo-uploaded span {
    display: block;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 5px;
}

.photo-uploaded small {
    font-size: 0.8rem;
    opacity: 0.8;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    max-width: 100%;
    display: block;
    margin-top: 5px;
    /* Nuevas propiedades añadidas */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.point-actions {
    display: flex;
    gap: 15px;
    justify-content: center;
    margin-top: 25px;
}

.btn-submit {
    padding: 15px 30px;
    font-size: 1.1rem;
    border-radius: 10px;
}

.completed-points {
    margin: 30px 0;
}

.completed-points h3 {
    color: #333;
    margin-bottom: 20px;
    text-align: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 10px;
}

.point-summary {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    background: white;
    border-radius: 12px;
    padding: 20px;
    margin: 15px 0;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    border-left: 4px solid #ddd;
}

.point-summary.maintenance {
    border-left-color: #28a745;
}

.point-summary.unrealizable {
    border-left-color: #ffc107;
}

.point-summary.pending {
    border-left-color: #dc3545;
}

.point-icon {
    font-size: 2rem;
    flex-shrink: 0;
}

.point-info {
    flex: 1;
}

.point-info h4 {
    margin: 0 0 8px 0;
    color: #333;
}

.point-info p {
    margin: 4px 0;
    color: #666;
    font-size: 0.9rem;
}

.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    flex-shrink: 0;
    align-self: flex-start;
}

.status-badge.success {
    background: #d4edda;
    color: #155724;
}

.status-badge.pending {
    background: #fff3cd;
    color: #856404;
}

.unrealizable-form {
    width: 100%;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 2px solid #f0f0f0;
}

.form-group-visual {
    margin: 15px 0;
}

.form-group-visual label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
    font-size: 1rem;
}

.select-visual, .textarea-visual {
    width: 100%;
    padding: 12px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.3s ease;
}

.select-visual:focus, .textarea-visual:focus {
    outline: none;
    border-color: #4facfe;
    box-shadow: 0 0 0 3px rgba(79, 172, 254, 0.1);
}

.file-upload-visual {
    display: flex;
    justify-content: center;
}

.file-upload-label {
    display: block;
    width: 100%;
    max-width: 250px;
    padding: 20px;
    border: 2px dashed #ffc107;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #fffbf0;
}

.file-upload-label:hover {
    border-color: #ff9500;
    background: #fff8e1;
}

.file-placeholder span {
    color: #ffc107;
    font-weight: 600;
}

.file-uploaded span {
    color: #28a745;
    font-weight: 600;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    max-width: 100%;
    display: block;
    padding: 0 5px;
    /* Nuevas propiedades añadidas */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.finish-section {
    text-align: center;
    margin: 40px 0 20px 0;
    padding-top: 30px;
    border-top: 2px solid #f0f0f0;
}

.btn-finish {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: white;
    border: none;
    padding: 18px 40px;
    border-radius: 12px;
    font-size: 1.2rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 280px;
}

.btn-finish:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
}

.btn-finish:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.form-section.lunch-mode {
    background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
    border: 3px solid #ff9500;
}

.lunch-header {
    text-align: center;
    margin-bottom: 30px;
}

.pause-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background: rgba(255, 149, 0, 0.1);
    padding: 15px;
    border-radius: 10px;
    margin: 20px 0;
    font-weight: 600;
    color: #ff9500;
}

.pause-icon {
    font-size: 1.5rem;
}

.lunch-actions {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
}

.or-divider {
    text-align: center;
    color: #666;
    font-style: italic;
    margin: 10px 0;
}

.form-section.finished {
    text-align: center;
    background: linear-gradient(135deg, #f0fff4 0%, #e6fffa 100%);
    border: 3px solid #28a745;
}

.success-header {
    margin-bottom: 30px;
}

.success-header h2 {
    color: #28a745;
    margin: 10px 0;
}

.summary-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 20px;
    margin: 30px 0;
}

.stat-card {
    background: white;
    padding: 25px;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    text-align: center;
    transition: transform 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
}

.stat-card.primary {
    border-top: 4px solid #007bff;
}

.stat-card.warning {
    border-top: 4px solid #ffc107;
}

.stat-card.info {
    border-top: 4px solid #17a2b8;
}

.stat-card.success {
    border-top: 4px solid #28a745;
}

.stat-card.lunch {
    border-top: 4px solid #ff9500;
}

.stat-card.operative {
    border-top: 4px solid #e83e8c;
}

.stat-card.danger-border {
    border-top: 5px solid #dc3545;
    background-color: #fff5f5;
}

.stat-card.success-border {
    border-top: 5px solid #28a745;
}

.stat-card.warning-border {
    border-top: 5px solid #ffc107;
    background-color: #fffdf5;
}

.stat-icon {
    font-size: 2.5rem;
    margin-bottom: 10px;
}

.stat-number {
    font-size: 2.5rem;
    font-weight: bold;
    color: #333;
    margin: 10px 0;
}

.stat-label {
    color: #666;
    font-size: 1rem;
    font-weight: 500;
}

.stat-sublabel {
    color: #999;
    font-size: 0.78rem;
    margin-top: 4px;
    font-style: italic;
}

.audit-alerts-container {
    background: white;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    margin-top: 20px;
    border: 2px solid #dc3545;
}

.audit-alert-header {
    background: #dc3545;
    color: white;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.audit-alert-header h3 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 700;
}

.audit-icon {
    font-size: 1.5rem;
}

.audit-alert-content {
    padding: 20px;
}

.audit-alert-content p {
    margin: 0 0 15px 0;
    color: #333;
    font-weight: 500;
}

.alert-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.alert-item {
    background: #fff5f5;
    border-radius: 8px;
    padding: 12px;
    border-left: 4px solid #dc3545;
}

.alert-item-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.alert-tag {
    font-weight: 700;
    color: #dc3545;
    font-size: 0.9rem;
}

.alert-dist {
    background: #dc3545;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 600;
}

.alert-message {
    margin: 0 !important;
    font-size: 0.85rem !important;
    color: #666 !important;
}

.audit-footer {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px dashed #ddd;
    text-align: center;
}

.audit-footer p {
    font-size: 0.85rem;
    color: #888;
    margin: 0;
    font-style: italic;
}

.btn {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;
    font-size: 1rem;
}

.btn-primary {
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    color: white;
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-success {
    background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
    color: white;
}

.btn-warning {
    background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
    color: #212529;
}

.btn-danger {
    background: #dc3545;
    color: white;
}

.btn-small {
    padding: 8px 15px;
    font-size: 0.9rem;
}

.btn:hover:not(:disabled) {
    opacity: 0.9;
    transform: translateY(-1px);
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.btn-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #6c757d !important;
    color: #fff !important;
}

.btn-disabled:hover {
    transform: none !important;
    opacity: 0.5 !important;
}

@media (max-width: 768px) {
    .header-content {
        flex-direction: column;
        gap: 15px;
    }

    .action-buttons {
        grid-template-columns: 1fr;
    }

    .point-actions {
        flex-direction: column;
    }

    .summary-stats {
        grid-template-columns: repeat(2, 1fr);
    }

    .point-summary {
        flex-direction: column;
        text-align: center;
        gap: 10px;
    }

    .photos-grid-dual {
        grid-template-columns: 1fr;
        gap: 15px;
        max-width: 100%;
    }

    .photo-upload-label {
        width: 100%;
        max-width: 100%;
        min-height: 120px;
        padding: 15px 10px;
    }

    h3 {
    color: #eba24f;       
    text-align: center;   
    }

    .photo-uploaded small {
        font-size: 0.7rem;
        line-height: 1.2;
        max-width: 100%;
        -webkit-line-clamp: 2;
        white-space: normal;
    }

    .file-upload-label {
        max-width: 100%;
        padding: 15px 10px;
    }

    .file-uploaded span {
        font-size: 0.9rem;
        line-height: 1.3;
        -webkit-line-clamp: 2;
        white-space: normal;
    }
}

@media (max-width: 480px) {
    .main-content {
        padding: 10px;
    }
    .form-section {
        padding: 15px;
    }
    .summary-stats {
        grid-template-columns: 1fr;
        gap: 15px;
        margin: 20px 0;
    }
    .stat-card {
        padding: 15px;
    }
    .stat-number {
        font-size: 1.8rem;
    }
    .stat-label {
        font-size: 0.9rem;
    }
    .metrics-and-audit-section {
        padding: 10px 0;
    }
}

/* 🆕 Animación para el banner de advertencia */
@keyframes pulse-warning {
    0% {
        transform: scale(1);
        box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);
    }
    50% {
        transform: scale(1.02);
        box-shadow: 0 6px 25px rgba(220, 53, 69, 0.7);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);
    }
}

/* Mejorar animación existente */
@keyframes pulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 20px 10px rgba(40, 167, 69, 0);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    }
}
            `}</style>
        </div>
    );
};

export default TechnicianPage;
